import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import TextField from "@material-ui/core/TextField";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Container from "@material-ui/core/Container";
import { api_path } from "../../shared.js";
import swal from "sweetalert";
import axios from "axios";
import { useSearchParams } from "react-router-dom";
import Select from "react-select";
import DateBox from "devextreme-react/date-box";
import AddBoxIcon from "@mui/icons-material/AddBox";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import RadioButton from "../RadioButton2.jsx";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import BseData from "./BseGridModal";
import ServiceModal from "./ServiceContractGridModal";
import { InputAdornment } from "@mui/material";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import MUIRichTextEditor from "mui-rte";
import { stateToHTML } from "draft-js-export-html";
import ReactHtmlParser from "react-html-parser";
import { convertFromHTML, ContentState, convertToRaw } from "draft-js";
import OrbitProgress from "react-loading-indicators/OrbitProgress";
import SaveIcon from "@mui/icons-material/Save";
import Tooltip from "@mui/material/Tooltip";
import OverweightModal from "./OverweightModal";
import { Tooltip2 } from "devextreme-react/tooltip";
export function SalesOrderFormContent(props) {
  // const getCrmId="64"
  // const getUserRole="1"
  // const getUserEmail="thanate.r@sinologistics.co.th"
  const [getCrmId, setCrmId] = useState(props.CRM_ID);
  const [getUserRole, setUserRole] = useState(props.USER_ROLE);
  const [getUserEmail, setUserEmail] = useState(props.USER_EMAIL);
  const [getEmpCode, setEmpCode] = useState(props.EMP_CODE);
  const [getSaleAuthenCode, setSaleAuthenCode] = useState("");
  const [GET_CONTENT, SET_CONTENT] = useState("");
  const [GET_CONTENT_CS, SET_CONTENT_CS] = useState("");
  const [GET_CONTENT_DOC, SET_CONTENT_DOC] = useState("");
  const [GET_CONTENT_ACC, SET_CONTENT_ACC] = useState("");
  const [getErrorMsg, setErrorMsg] = useState([]);
  const [showErrorComment, setShowErrorComment] = useState("");
  const [containerInputs, setContainerInputs] = useState([
    {
      CTNR_ITEM_ID: "",
      CTNR_SIZE: "",
      CTNR_TYPE: "",
      CTNR_QTY: "",
      CTNR_UNIT: "",
      CTNR_CBM: "",
      GW: "",
      CTNR_REMARK: "",
    },
  ]);
  const [editorContent, setEditorContent] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [checkUplodaFile, setUplodaFile] = useState(false);
  const [isDisableDup, setDisableDup] = useState(false);
  const [isDisabledLoadType, setIsDisabledLoadType] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const order_id = searchParams.get("order_id");
  const copy_id = searchParams.get("copy_id");
  const type = searchParams.get("type");
  const param_loadtype = searchParams
    .get("loadtype")
    .substring(
      searchParams.get("loadtype").length,
      searchParams.get("loadtype").length - 3
    )
    .toLowerCase();
  const docno = searchParams.get("docno");
  const SALES_CRM_UID = searchParams.get("SALES_CRM_UID");
  const scode = searchParams.get("scode");
  const sname = searchParams.get("sname");
  /*new containerFields*/
  const containerFields = [
    { key: "20", label: "20'" },
    { key: "40", label: "40'" },
    { key: "40HQ", label: "40HQ'" },
    { key: "45", label: "45'" },
  ];
  const [containers, setContainers] = useState({
    20: { type: "", cnt: "", gw: "", errors: {} },
    40: { type: "", cnt: "", gw: "", errors: {} },
    "40HQ": { type: "", cnt: "", gw: "", errors: {} },
    45: { type: "", cnt: "", gw: "", errors: {} },
  });
  const updateContainer = (size, field, value) => {
    setContainers((prev) => ({
      ...prev,
      [size]: {
        ...prev[size],
        [field]: value,
      },
    }));
  };
  /*End new containerFields*/
  const [GET_DUP_ORDER, SET_DUP_ORDER] = useState(1);
  const [GET_REMARK_TO_REPORT, SET_REMARK_TO_REPORT] = useState("")
  const [GET_GW, SET_GW] = useState("");
  const [GET_NO_OF_PACK, SET_NO_OF_PACK] = useState("");
  const [GET_PACKAGE_UNIT, SET_PACKAGE_UNIT] = useState("");
  const [GET_CBM, SET_CBM] = useState("");
  const [GET_DIMENSION_NOTE, SET_DIMENSION_NOTE] = useState("");

  const [GET_USER_EMAIL, SET_USER_EMAIL] = useState("");
  const [GET_OPEN_MODAL, SET_OPEN_MODAL] = useState("");
  const [showCancelBtn, setShowCancelBtn] = useState(false);
  const [isButtonCancelDisabled, setButtonCancelDisabled] = useState(true);
  const [showLCL, setShowLCL] = useState(false);
  const [showFCL, setShowFCL] = useState(false);
  const [showDelBtn, setShowDelBtn] = useState(false);
  const [showOrderNo, setShowOrderNo] = useState(false);
  const [isSubmitting, setSubmitting] = useState(false);
  const [isButtonDisabled, setButtonDisabled] = useState(true);
  const [subjectName, setSubjectName] = useState("");
  const [GET_ORDER_NO, SET_ORDER_NO] = useState("");
  const [GET_QUOTATION_NO, SET_QUOTATION_NO] = useState("");
  const [GET_ORDER_STATUS_ID, SET_ORDER_STATUS_ID] = useState("");
  const [GET_ORDER_STATUS_NAME, SET_ORDER_STATUS_NAME] = useState("");
  const [GET_CUSTOMER_REF, SET_CUSTOMER_REF] = useState("");
  const [GET_WAITING_FLAG, SET_WAITING_FLAG] = useState("N");
  const [GET_PRE_COOL, SET_PRE_COOL] = useState("N");
  const [GET_VENT, SET_VENT] = useState("");
  const [GET_BOUND_TYPE, SET_BOUND_TYPE] = useState("EXPORT");
  const [GET_DOOR_BY, SET_DOOR_BY] = useState("AGENT");
  const [GET_SHIPMENT_TERM, SET_SHIPMENT_TERM] = useState("");
  const [GET_PARTY_3RD_NAME, SET_PARTY_3RD_NAME] = useState("");
  const [GET_CREDIT_TERM, SET_CREDIT_TERM] = useState("");
  const [GET_POR, SET_POR] = useState(null);
  const [GET_POL, SET_POL] = useState(null);
  const [GET_POD, SET_POD] = useState(null);
  const [GET_DEL, SET_DEL] = useState(null);
  const [GET_FINAL, SET_FINAL] = useState(null);
  const [GET_FINAL_ADDRESS, SET_FINAL_ADDRESS] = useState("");
  const [GET_DG_CLASS, SET_DG_CLASS] = useState("");
  const [GET_HUMIDITY, SET_HUMIDITY] = useState("");
  const [GET_HSCODE, SET_HSCODE] = useState("");
  const [GET_COMMODITY, SET_COMMODITY] = useState("");
  const [GET_SHIPPING, SET_SHIPPING] = useState("");
  const [GET_TRUCKING, SET_TRUCKING] = useState([]);
  const [TRUCKBY_LIST, SET_TRUCKBY_LIST] = useState([]);
  const [GET_SELECT_TRUCKBY, SET_SELECT_TRUCKBY] = useState([]);
  const [GET_TRUCKBY_REMARK, SET_TRUCKBY_REMARK] = useState("");
  const [GET_INSURANCE, SET_INSURANCE] = useState("");
  const [GET_SHIPPING_DEL, SET_SHIPPING_DEL] = useState("");
  const [GET_TRUCKING_DEL, SET_TRUCKING_DEL] = useState("");
  const [GET_AGENT_SALES_EMAIL, SET_AGENT_SALES_EMAIL] = useState("");
  // const [GET_ISF_BY, SET_ISF_BY] = useState("AGENT");
  // const [GET_AMS_SCAC, SET_AMS_SCAC] = useState("SINO");
  const [GET_FILING_BY, SET_FILING_BY] = useState("");
  const [GET_PREALERT_EMAIL, SET_PREALERT_EMAIL] = useState("");
  const [GET_BOOKING_PIC, SET_BOOKING_PIC] = useState("");
  const [GET_DOC_PIC, SET_DOC_PIC] = useState("");
  const [GET_REMARK_TO_CS, SET_REMARK_TO_CS] = useState("");
  const [GET_REMARK_TO_DOC, SET_REMARK_TO_DOC] = useState("");
  const [GET_REMARK_TO_ACC, SET_REMARK_TO_ACC] = useState("");

  const [GET_AMS_SCAC, SET_AMS_SCAC] = useState([]);
  const [AMS_SCAC_LIST, SET_AMS_SCAC_LIST] = useState([]);
  const [SELECT_AMS_SCAC, SET_SELECT_AMS_SCAC] = useState([]);

  const [GET_ISF_BY, SET_ISF_BY] = useState([]);
  const [ISF_BY_LIST, SET_ISF_BY_LIST] = useState([]);
  const [SELECT_ISF_BY, SET_SELECT_ISF_BY] = useState([]);

  const [getSale, setSale] = useState([]);
  const [saleList, setSaleList] = useState([]);
  const [selectSale, setSelectSale] = useState([]);

  const [getCs, setCs] = useState([]);
  const [csList, setCsList] = useState([]);
  const [selectCs, setSelectCs] = useState([]);
  const [getPriority, setPriority] = useState([]);
  const [priorityList, setPriorityList] = useState([]);
  const [selectPriority, setSelectPriority] = useState([]);

  const [getShipper, setShipper] = useState([]);
  const [shipperList, setShipperList] = useState([]);
  const [selectShipper, setSelectShipper] = useState([]);
  const [getConsignee, setConsignee] = useState([]);
  const [ConsigneeList, setConsigneeList] = useState([]);
  const [selectConsignee, setSelectConsignee] = useState([]);
  const [getAgent, setAgent] = useState([]);
  const [agentList, setAgentList] = useState([]);
  const [selectAgent, setSelectAgent] = useState([]);
  const [getShipperLoad, setShipperLoad] = useState([]);
  const [shipperLoadList, setShipperLoadList] = useState([]);
  const [selectShipperLoad, setSelectShipperLoad] = useState([]);
  const [getCoload, setCoload] = useState([]);
  const [coloadList, setColoadList] = useState([]);
  const [selectCoload, setSelectCoload] = useState([]);
  const [getCarrier, setCarrier] = useState([]);
  const [carrierList, setCarrierList] = useState([]);
  const [selectCarrier, setSelectCarrier] = useState([]);
  const [getServiceContract, setServiceContract] = useState([]);
  const [serviceContractList, setServiceContractList] = useState([]);
  const [selectServiceContract, setSelectServiceContract] = useState([]);
  const [getPor, setPor] = useState([]);
  const [porList, setPorList] = useState([]);
  const [selectPor, setSelectPor] = useState([]);
  const [getPol, setPol] = useState([]);
  const [polList, setPolList] = useState([]);
  const [selectPol, setSelectPol] = useState([]);
  const [getPod, setPod] = useState([]);
  const [podList, setPodList] = useState([]);
  const [selectPod, setSelectPod] = useState([]);
  const [getDel, setDel] = useState([]);
  const [delList, setDelList] = useState([]);
  const [selectDel, setSelectDel] = useState([]);
  const [getFinal, setFinal] = useState([]);
  const [finalList, setFinalList] = useState([]);
  const [selectFinal, setSelectFinal] = useState([]);
  const [getIncoterm, setIncoterm] = useState([]);
  const [selectIncoterm, setSelectIncoterm] = useState();
  const [getCyTerm, setCyTerm] = useState([]);
  const [cyTermList, setCyTermList] = useState([]);
  const [selectCyTerm, setSelectCyTerm] = useState([]);
  const [getLoadType, setLoadType] = useState([]);
  const [loadTypeList, setLoadTypeList] = useState([]);
  const [selectLoadType, setSelectLoadType] = useState([]);
  const [getCargoType, setCargoType] = useState([]);
  const [cargoTypeList, setcargoTypeList] = useState([]);
  const [selectCargoType, setSelectCargoType] = useState([]);
  const [getMBLTerm, setMBLTerm] = useState([]);
  const [selectMBLTerm, setSelectMBLTerm] = useState([]);

  const [selectMBLType, setSelectMBLType] = useState([]);
  const [getHBLTerm, setHBLTerm] = useState([]);
  const [selectHBLTerm, setSelectHBLTerm] = useState();
  const [getHBLType, setHBLType] = useState([]);
  const [selectHBLType, setSelectHBLType] = useState();
  const [showUploadMsg, setShowUploadMsg] = useState(
    "Choose file before Pressing the Upload button."
  );
  const [getNAC, setNAC] = useState(0);
  const [getDG, setDG] = useState("");
  const [showReefer, setShowReefer] = useState(false);
  const [showDG, setShowDG] = useState(false);
  const [showDoorBy, setShowDoorBy] = useState(false);
  const [GET_JOB_OWNER, SET_JOB_OWNER] = useState("");
  const [radioStatusSoldBy, setRadioStatusSoldBy] = useState("");
  const [GET_BOOKING_BY, SET_BOOKING_BY] = useState("");
  const [GET_CUSTOMER_CODE_FLAG, SET_CUSTOMER_CODE_FLAG] = useState("NO");
  const [GET_PAPERLESS_CODE_FLAG, SET_PAPERLESS_CODE_FLAG] = useState("NO");
  const [GET_CUSTOMER_CODE, SET_CUSTOMER_CODE] = useState("");
  const [GET_PAPERLESS_CODE, SET_PAPERLESS_CODE] = useState("");
  const [GET_INVOICE_CHARGE_TO, SET_INVOICE_CHARGE_TO] = useState("");

  const now = new Date();
  const dateLabel = { "aria-label": "Date" };
  var date = new Date();
  var today = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  var lastDay = new Date(date.getFullYear(), date.getMonth() + 2, 0);
  const formattedtoday = today
    .toLocaleDateString("en-GB", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    })
    .split("/")
    .reverse()
    .join("-");
  const formattedtoday2 = today
    .toLocaleDateString("en-GB", {
      year: "2-digit",
      month: "2-digit",
      day: "2-digit",
    })
    .split("/")
    .reverse()
    .join("");
  function getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1) + min);
  }
  const [GET_RANDOM_KEY, SET_RANDOM_KEY] = useState(
    formattedtoday2 + "" + Math.floor(date.getTime() / 1000)
  );
  const [GET_ORDER_DATE, SET_ORDER_DATE] = useState(formattedtoday);
  const [getCargoReady, setCargoReady] = useState(null);
  const [getCyDate, setCyDate] = useState(null);
  const [getReturnDate, setReturnDate] = useState(null);
  const [getEtdDate, setEtdDate] = useState(null);
  const [getEtaDate, setEtaDate] = useState(null);
  const onValueChangedCargoReady = React.useCallback((e) => {
    if (e.value) {
      const dateFrom = new Date(e.value);
      const formattedDateFrom = dateFrom
        .toLocaleDateString("en-GB", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        })
        .split("/")
        .reverse()
        .join("-");
      setCargoReady(formattedDateFrom);
    } else {
      setCargoReady(null);
    }
  }, []);
  const onValueChangedCyDate = React.useCallback((e) => {
    if (e.value) {
      const dateTo = new Date(e.value);
      const formattedDateTo = dateTo
        .toLocaleDateString("en-GB", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        })
        .split("/")
        .reverse()
        .join("-");
      setCyDate(formattedDateTo);
    } else {
      setCyDate(null);
    }
  }, []);
  const onValueChangedReturnDate = React.useCallback((e) => {
    if (e.value) {
      const dateTo = new Date(e.value);
      const formattedDateTo = dateTo
        .toLocaleDateString("en-GB", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        })
        .split("/")
        .reverse()
        .join("-");
      setReturnDate(formattedDateTo);
    } else {
      setReturnDate(null);
    }
  }, []);
  const onValueChangedEtdDate = React.useCallback((e) => {
    if (e.value) {
      const dateTo = new Date(e.value);
      const formattedDateTo = dateTo
        .toLocaleDateString("en-GB", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        })
        .split("/")
        .reverse()
        .join("-");
      setEtdDate(formattedDateTo);
    } else {
      setEtdDate(null);
    }
  }, []);
  const onValueChangedEtaDate = React.useCallback((e) => {
    if (e.value) {
      const dateTo = new Date(e.value);
      const formattedDateTo = dateTo
        .toLocaleDateString("en-GB", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        })
        .split("/")
        .reverse()
        .join("-");
      setEtaDate(formattedDateTo);
    } else {
      setEtaDate(null);
    }
  }, []);
  useEffect(() => {
    if (param_loadtype == "lcl") {
      setSelectLoadType("LCL");
      setLoadType({
        value: "LCL",
        label: "LCL",
      });
      setShowLCL(true);
      setShowFCL(false);
    } else if (param_loadtype == "fcl") {
      setShowLCL(false);
      setShowFCL(true);
    } else {
      setShowLCL(false);
      setShowFCL(true);
    }
    if (getUserRole == 1) {
      //sales
      setSaleAuthenCode(getCrmId);
      setSelectSale(getCrmId);
      setSale({
        SALE_CODE: getCrmId,
        SALE_NAME: getUserEmail,
      });
    } else if (getUserRole == 7) {
      setSaleAuthenCode(getCrmId);
      setSelectSale(getCrmId);
      setSale({
        SALE_CODE: getCrmId,
        SALE_NAME: getUserEmail,
      });
    } else if (getUserRole == 2) {
      //sales co
      if (docno) {
      } else {
        fetchSale();
      }
    }
    fetchCS();
    fetchCarrier();
    fetchPort();
    console.log(CarrierInputs);
  }, []);
  useEffect(() => {
    console.log("editor state", GET_CONTENT);
    //setIsLoading(true);
    if (order_id || copy_id) {
      if (order_id) {
        setShowOrderNo(true);
        setDisableDup(true);
        SET_OPEN_MODAL(0);
      } else {
        setDisableDup(false);
        setShowOrderNo(false);
      }
      let id = 0;
      if (order_id) {
        id = order_id;
        setSubjectName("Edit Sales Order");
        fetchCarrierData(id);
      } else if (copy_id) {
        id = copy_id;
        setSubjectName("Copy Sales Order");
        setCarrierInputs(initialList);
      }
      //view or edit
      fetch(api_path + "/TS_SALES_ORDER.php?order_id=" + id)
        .then((res) => res.json())
        .then((res) => {
          const array = res;
          for (const i of array) {
            SET_FINAL_ADDRESS(i.FINAL_ADDRESS);
            SET_USER_EMAIL(i.USER_EMAIL);
            SET_ORDER_NO(i.ORDER_NO);
            SET_ORDER_STATUS_ID(i.ORDER_STATUS);
            SET_ORDER_STATUS_NAME(i.STATUS_NAME);
            if (i.ORDER_STATUS == "0") {
              setShowCancelBtn(false);
            } else if (i.ORDER_STATUS == "9") {
              setShowCancelBtn(false);
              // if (copy_id) {
              //   setButtonDisabled(true);
              // } else {
              //   setButtonDisabled(false);
              // }
            } else {
              if (order_id) {
                setShowCancelBtn(true);
              } else {
                setShowCancelBtn(false);
              }
            }
            if (order_id) {
              SET_QUOTATION_NO(i.QUOTATION_NO);
              SET_CUSTOMER_REF(i.CUSTOMER_REF);
            } else if (copy_id) {
              SET_QUOTATION_NO("");
              SET_CUSTOMER_REF("");
            }

            setSaleAuthenCode(i.SALES_ID);
            setSelectSale(i.SALES_ID);
            setSale({
              SALE_CODE: i.SALES_ID,
              SALE_NAME: i.SALE_EMAIL,
            });
            setCargoReady(i.CARGO_READY);
            setEtdDate(i.ETD_DATE);
            setEtaDate(i.ETA_DATE);
            setCyDate(i.CY_DATE);
            setReturnDate(i.RETURN_DATE);
            if (i.BOUND_TYPE == "EXPORT") {
              setRadioStatus("EXPORT");
              SET_BOUND_TYPE("EXPORT");
            } else if (i.BOUND_TYPE == "IMPORT") {
              setRadioStatus("IMPORT");
              SET_BOUND_TYPE("IMPORT");
            }
            if (i.JOBOWNER == "FREEHAND") {
              setRadioStatusSoldBy("FREEHAND");
              SET_JOB_OWNER("FREEHAND");
            } else if (i.JOBOWNER == "NOMINATE") {
              setRadioStatusSoldBy("NOMINATE");
              SET_JOB_OWNER("NOMINATE");
            }
            if (i.BOOKING_BY == "SINO") {
              setRadioStatusBookingBy("SINO");
              SET_BOOKING_BY("SINO");
            } else if (i.BOOKING_BY == "AGENT") {
              setRadioStatusBookingBy("AGENT");
              SET_BOOKING_BY("AGENT");
            }
            if (i.DOOR_BY == "AGENT") {
              setRadioStatusDoorBy("AGENT");
              SET_DOOR_BY("AGENT");
            } else if (i.DOOR_BY == "CARRIER") {
              setRadioStatusDoorBy("CARRIER");
              SET_DOOR_BY("CARRIER");
            } else {
              SET_DOOR_BY("");
            }
            if (copy_id) {
              setAttachment("");
            } else {
              setAttachment(i.ATTACHMENT);
            }
            SET_SELECT_AMS_SCAC(i.AMS_SCAC);
            SET_AMS_SCAC({
              value: i.AMS_SCAC,
              label: i.AMS_SCAC,
            });
            SET_SELECT_ISF_BY(i.ISF_BY);
            SET_ISF_BY({
              value: i.ISF_BY,
              label: i.ISF_BY,
            });
            SET_SHIPMENT_TERM(i.SHIPMENT_TERM);
            SET_PARTY_3RD_NAME(i.PARTY_3RD_NAME);
            SET_CREDIT_TERM(i.CREDIT_TERM);
            SET_HSCODE(i.HSCODE);
            SET_COMMODITY(i.COMMODITY);
            SET_SHIPPING(i.SHIPPING);
            SET_TRUCKBY_REMARK(i.TRUCKBY_REMARK);
            SET_SELECT_TRUCKBY(i.TRUCKING);
            SET_TRUCKING({
              value: i.TRUCKING,
              label: i.TRUCKING,
            });
            SET_TRUCKBY_REMARK(i.TRUCKING_REMARK);
            SET_INSURANCE(i.INSURANCE);
            SET_SHIPPING_DEL(i.SHIPPING_DEL);
            SET_TRUCKING_DEL(i.TRUCKING_DEL);
            SET_AGENT_SALES_EMAIL(i.AGENT_SALES_EMAIL);

            SET_PREALERT_EMAIL(i.PREALERT_EMAIL);
            SET_BOOKING_PIC(i.BOOKING_PIC);
            SET_DOC_PIC(i.DOC_PIC);
            SET_REMARK_TO_CS(i.REMARK_TO_CS);
            SET_REMARK_TO_DOC(i.REMARK_TO_DOC);
            SET_REMARK_TO_ACC(i.REMARK_TO_ACC);
            SET_REMARK_TO_REPORT(i.REMARK_TO_REPORT)
            setSelectShipper(i.SHIPPER_CODE);
            setShipper({
              COM_CODE: i.SHIPPER_CODE,
              COM_NAME: i.SHIPPER_NAME,
            });
            setSelectConsignee(i.CNEE_CODE);
            setConsignee({
              COM_CODE: i.CNEE_CODE,
              COM_NAME: i.CNEE_NAME,
            });
            setSelectAgent(i.AGENT_CODE);
            setAgent({
              COM_CODE: i.AGENT_CODE,
              COM_NAME: i.AGENT_NAME,
            });
            setSelectShipperLoad(i.SHIPPERLOAD_CODE);
            setShipperLoad({
              COM_CODE: i.SHIPPERLOAD_CODE,
              COM_NAME: i.SHIPPERLOAD_NAME,
            });
            setSelectCoload(i.COLOAD_CODE);
            setCoload({
              COM_CODE: i.COLOAD_CODE,
              COM_NAME: i.COLOAD_NAME,
            });
            setSelectLoadType(i.LOADTYPE);
            setLoadType({
              value: i.LOADTYPE,
              label: i.LOADTYPE,
            });
            setSelectIncoterm(i.INCOTERM);
            setIncoterm({
              value: i.INCOTERM,
              label: i.INCOTERM,
            });
            setSelectCyTerm(i.CYTERM);
            setCyTerm({
              value: i.CYTERM,
              label: i.CYTERM,
            });
            var last4 = i.CYTERM.slice(-4);
            if (last4 == "DOOR") {
              setShowDoorBy(true);
            } else {
              setShowDoorBy(false);
            }
            setSelectMBLTerm(i.MBL_TERM);
            setMBLTerm({
              value: i.MBL_TERM,
              label: i.MBL_TERM,
            });
            setSelectMBLType(i.MBL_TYPE);
            setMBLType({
              value: i.MBL_TYPE,
              label: i.MBL_TYPE,
            });
            setSelectHBLTerm(i.HBL_TERM);
            setHBLTerm({
              value: i.HBL_TERM,
              label: i.HBL_TERM,
            });
            setSelectHBLType(i.HBL_TYPE);
            setHBLType({
              value: i.HBL_TYPE,
              label: i.HBL_TYPE,
            });
            SET_POR(i.POR);
            SET_POD(i.POD);
            SET_POL(i.POL);
            SET_DEL(i.DEL);
            SET_FINAL(i.FINAL);
            setSelectCargoType(i.CARGO_TYPE);
            setCargoType({
              value: i.CARGO_TYPE,
              label: i.CARGO_TYPE,
            });
            if (i.CARGO_TYPE == "DG") {
              SET_DG_CLASS(i.DG_CLASS);
              setRequire("required");
              setShowDG(true);
              setShowReefer(false);
            } else if (i.CARGO_TYPE == "REEFER") {
              SET_DG_CLASS(i.TEMPERATURE);
              setRequire("required");
              setShowDG(true);
              setShowReefer(false);
            } else {
              setRequire("");
              setShowDG(false);
            }
            if (i.CARGO_TYPE == "REEFER") {
              setShowReefer(true);
              setShowDG(false);
            }
            setSelectCs(i.CS_ID);
            setCs({
              CS_ID: i.CS_ID,
              CS_EMAIL: i.CS_EMAIL,
            });
            SET_ORDER_DATE(i.ORDER_DATE);
            if (order_id) {
              SET_GW(i.GW);
            }
            setContainers({
              20: {
                type: i.TYPE20 ?? "",
                cnt: i.CNT20 ?? "",
                gw: i.GW20 ?? "",
                errors: {},
              },
              40: {
                type: i.TYPE40 ?? "",
                cnt: i.CNT40 ?? "",
                gw: i.GW40 ?? "",
                errors: {},
              },
              "40HQ": {
                type: i.TYPE40HQ ?? "",
                cnt: i.CNT40HQ ?? "",
                gw: i.GW40HQ ?? "",
                errors: {},
              },
              45: {
                type: i.TYPE45 ?? "",
                cnt: i.CNT45 ?? "",
                gw: i.GW45 ?? "",
                errors: {},
              },
            });
            SET_NO_OF_PACK(i.NO_OF_PACK);
            SET_PACKAGE_UNIT(i.PACKAGE_UNIT);
            SET_CBM(i.CBM);

            SET_DIMENSION_NOTE(i.DIMENSION_NOTE);
            SET_REMARK_TO_CS(i.REMARK_TO_CS);
            SET_REMARK_TO_DOC(i.REMARK_TO_DOC);
            SET_REMARK_TO_ACC(i.REMARK_TO_ACC);
            let contentHTML, contentCS, contentDoc, contentAcc;
            //1. Convert the HTML
            // contentHTML = convertFromHTML(i.DIMENSION_NOTE);
            //  contentCS = convertFromHTML(i.REMARK_TO_CS);
            //   contentDoc = convertFromHTML(i.REMARK_TO_DOC);
            //    contentAcc = convertFromHTML(i.REMARK_TO_ACC);
            contentHTML = convertFromHTML(i.DIMENSION_NOTE || "");
            contentCS = convertFromHTML(i.REMARK_TO_CS || "");
            contentDoc = convertFromHTML(i.REMARK_TO_DOC || "");
            contentAcc = convertFromHTML(i.REMARK_TO_ACC || "");
            // 2. Create the ContentState object
            let state, state2, state3, state4;
            state = ContentState.createFromBlockArray(
              contentHTML.contentBlocks,
              contentHTML.entityMap
            );
            state2 = ContentState.createFromBlockArray(
              contentCS.contentBlocks,
              contentCS.entityMap
            );
            state3 = ContentState.createFromBlockArray(
              contentDoc.contentBlocks,
              contentDoc.entityMap
            );
            state4 = ContentState.createFromBlockArray(
              contentAcc.contentBlocks,
              contentAcc.entityMap
            );
            // 3. Stringify `state` object from a Draft.Model.Encoding.RawDraftContentState object
            SET_CONTENT(JSON.stringify(convertToRaw(state)));
            SET_CONTENT_CS(JSON.stringify(convertToRaw(state2)));
            SET_CONTENT_DOC(JSON.stringify(convertToRaw(state3)));
            SET_CONTENT_ACC(JSON.stringify(convertToRaw(state4)));
            if (i.WAITING_FLAG == "Y") {
              setRadioStatusWaitingFlag("Y");
              SET_WAITING_FLAG("Y");
            } else if (i.WAITING_FLAG == "N") {
              setRadioStatusWaitingFlag("N");
              SET_WAITING_FLAG("N");
            }
            if (i.PRE_COOL == "Y") {
              setRadioStatusPrecool("Y");
              SET_PRE_COOL("Y");
            } else if (i.PRE_COOL == "N") {
              setRadioStatusPrecool("N");
              SET_PRE_COOL("N");
            }

            SET_HUMIDITY(i.HUMIDITY);
            SET_VENT(i.VENT);
            setSelectPriority(i.BOOK_PRIORITY_CODE);
            setPriority({
              value: i.BOOK_PRIORITY_CODE,
              label: i.BOOK_PRIORITY,
            });
            SET_CUSTOMER_CODE(i.CUSTOMER_CODE);
            SET_PAPERLESS_CODE(i.PAPERLESS_CODE);
            SET_INVOICE_CHARGE_TO(i.INVOICE_CHARGE_TO);
          }
        });
    } else if (docno) {
      SET_USER_EMAIL(getUserEmail);
      //from bse
      fetch(api_path + "/TMP_BSE.php?docno=" + docno + "&search=1")
        .then((res) => res.json())
        .then((res) => {
          const array = res;
          for (const i of array) {
            setSubjectName("New Sales Order [" + param_loadtype + "]");
            setSaleAuthenCode(i.SALE_ID);
            setSelectSale(i.SALE_ID);
            setSale({
              SALE_CODE: i.SALE_ID,
              SALE_NAME: i.SALE_EMAIL,
            });
            if (i.JOBCLASS == "EX") {
              setRadioStatus("EXPORT")
              SET_BOUND_TYPE("EXPORT");
            } else {
              setRadioStatus("IMPORT")
              SET_BOUND_TYPE("IMPORT");
            }
            // console.log("JOBCLASS ...."+i.JOBCLASS)
            if (i.JOBOWNER == "FREEHAND") {
              setRadioStatusSoldBy("FREEHAND");
              SET_JOB_OWNER("FREEHAND");
            } else if (i.JOBOWNER == "NOMINATE") {
              setRadioStatusSoldBy("NOMINATE");
              SET_JOB_OWNER("NOMINATE");
            }
            if (i.BOOKING_BY == "SINO") {
              setRadioStatusBookingBy("SINO");
              SET_BOOKING_BY("SINO");
            } else if (i.BOOKING_BY == "AGENT") {
              setRadioStatusBookingBy("AGENT");
              SET_BOOKING_BY("AGENT");
            }
            if (i.DOOR_BY == "AGENT") {
              SET_DOOR_BY("AGENT");
            } else {
              SET_DOOR_BY("CARRIER");
            }
            // if (i.ISF_BY == "AGENT") {
            //   SET_ISF_BY("AGENT");
            // } else {
            //   SET_ISF_BY("CNEE/SHIPPER");
            // }
            // if (i.AMS_SCAC == "SINO") {
            //   SET_AMS_SCAC("SINO");
            // } else {
            //   SET_AMS_SCAC("COLOADER");
            // }
            SET_SELECT_AMS_SCAC(i.AMS_SCAC);
            SET_AMS_SCAC({
              value: i.AMS_SCAC,
              label: i.AMS_SCAC,
            });
            SET_SELECT_ISF_BY(i.ISF_BY);
            SET_ISF_BY({
              value: i.ISF_BY,
              label: i.ISF_BY,
            });

            SET_SHIPMENT_TERM(i.SHIPMENT_TERM);
            SET_PARTY_3RD_NAME(i.PARTY_3RD_NAME);
            SET_CREDIT_TERM(i.CREDIT_TERM);
            SET_HSCODE(i.HSCODE);
            SET_COMMODITY(i.COMMODITY);
            SET_SHIPPING(i.SHIPPING);
            SET_TRUCKING(i.TRUCKING);
            SET_INSURANCE(i.INSURANCE);
            SET_SHIPPING_DEL(i.SHIPPING_DEL);
            SET_TRUCKING_DEL(i.TRUCKING_DEL);
            SET_AGENT_SALES_EMAIL(i.AGENT_SALES_EMAIL);

            //SET_FILING_BY(i.FILING_BY);
            SET_PREALERT_EMAIL(i.PREALERT_EMAIL);
            SET_BOOKING_PIC(i.BOOKING_PIC);
            SET_DOC_PIC(i.DOC_PIC);
            SET_REMARK_TO_CS(i.REMARK_TO_CS);
            SET_REMARK_TO_DOC(i.REMARK_TO_DOC);
            SET_REMARK_TO_ACC(i.REMARK_TO_ACC);
            SET_REMARK_TO_REPORT(i.REMARK_TO_REPORT)
            if (i.INCOTERM) {
              setSelectIncoterm(i.INCOTERM);
              setIncoterm({
                value: i.INCOTERM,
                label: i.INCOTERM,
              });
            }
            if (i.SHIPPER_CODE) {
              setSelectShipper(i.SHIPPER_CODE);
              setShipper({
                COM_CODE: i.SHIPPER_CODE,
                COM_NAME: i.SHIPPER_NAME,
              });
            }

            if (i.CNEE_CODE) {
              setSelectConsignee(i.CNEE_CODE);
              setConsignee({
                COM_CODE: i.CNEE_CODE,
                COM_NAME: i.CNEE_NAME,
              });
            }

            if (i.AGENT_CODE) {
              setSelectAgent(i.AGENT_CODE);
              setAgent({
                COM_CODE: i.AGENT_CODE,
                COM_NAME: i.AGENT_NAME,
              });
            }
            if (i.SHIPPERLOAD_CODE) {
              setSelectShipperLoad(i.SHIPPERLOAD_CODE);
              setShipperLoad({
                COM_CODE: i.SHIPPERLOAD_CODE,
                COM_NAME: i.SHIPPERLOAD_NAME,
              });
            }
            if (i.COLOAD_CODE) {
              setSelectCoload(i.COLOAD_CODE);
              setCoload({
                COM_CODE: i.COLOAD_CODE,
                COM_NAME: i.COLOAD_NAME,
              });
            }

            if (param_loadtype == "lcl") {
              setSelectLoadType("LCL");
              setLoadType({
                value: "LCL",
                label: "LCL",
              });
            } else {
              if (i.LOADTYPE) {
                setSelectLoadType(i.LOADTYPE);
                setLoadType({
                  value: i.LOADTYPE,
                  label: i.LOADTYPE,
                });
              }
            }
            if (i.INCOTERM) {
              setSelectIncoterm(i.INCOTERM);
              setIncoterm({
                value: i.INCOTERM,
                label: i.INCOTERM,
              });
            }
            if (i.CYTERM) {
              setSelectCyTerm(i.CYTERM);
              setCyTerm({
                value: i.CYTERM,
                label: i.CYTERM,
              });
            }
            if (i.MBL_TERM) {
              setSelectMBLTerm(i.MBL_TERM);
              setMBLTerm({
                value: i.MBL_TERM,
                label: i.MBL_TERM,
              });
            }
            if (i.MBL_TYPE) {
              setSelectMBLType(i.MBL_TYPE);
              setMBLType({
                value: i.MBL_TYPE,
                label: i.MBL_TYPE,
              });
            }
            if (i.HBL_TERM) {
              setSelectHBLTerm(i.HBL_TERM);
              setHBLTerm({
                value: i.HBL_TERM,
                label: i.HBL_TERM,
              });
            }
            if (i.HBL_TYPE) {
              setSelectHBLType(i.HBL_TYPE);
              setHBLType({
                value: i.HBL_TYPE,
                label: i.HBL_TYPE,
              });
            }
            SET_POR(i.POR);
            SET_POD(i.POD);
            SET_POL(i.POL);
            SET_DEL(i.DEL);
            SET_FINAL(i.FINAL);
            setCarrierInputs(initialList);
          }
        });
    } else if (SALES_CRM_UID) {
      setCarrierInputs(initialList);
      SET_USER_EMAIL(getUserEmail);
      setSubjectName("New Sales Order [" + param_loadtype + "]");
      setRadioStatusSoldBy("FREEHAND");
      SET_JOB_OWNER("FREEHAND");
      setRadioStatusBookingBy("SINO");
      SET_BOOKING_BY("SINO");
    } else if (type == 1) {
      setCarrierInputs(initialList);
      SET_USER_EMAIL(getUserEmail);
      setSubjectName("New Sales Order [" + param_loadtype + "]");
      setRadioStatusSoldBy("FREEHAND");
      SET_JOB_OWNER("FREEHAND");
      setRadioStatusBookingBy("SINO");
      SET_BOOKING_BY("SINO");
    } else {
      setCarrierInputs(initialList);
      SET_USER_EMAIL(getUserEmail);
      setSubjectName("New Sales Order [" + param_loadtype + "]");
      setRadioStatusSoldBy("FREEHAND");
      SET_JOB_OWNER("FREEHAND");
      setRadioStatusBookingBy("SINO");
      SET_BOOKING_BY("SINO");
    }
  }, [order_id]);

  const [errors, setErrors] = useState({});
  const validateForm = () => {
    const errors = {};

    if (!GET_QUOTATION_NO.trim()) {
      errors.quotation = "Quotaion No is required";
    }
    if (getSale.length === 0) {
      errors.getSaleError = "Sales is required";
    }
    if (getCs.length === 0) {
      errors.getCsError = "CS is required";
    }
    if (
      !getCargoReady &&
      !getCyDate &&
      !getReturnDate &&
      !getEtdDate &&
      !getEtaDate
    ) {
      errors.etdDate =
        "Please input Cargo ready or CY date or Return date or ETD date or ETA date";
    }
    if (!GET_POR) {
      errors.por = "POR is required";
    }
    if (!GET_POL) {
      errors.pol = "POL is required";
    }
    if (!GET_POD) {
      errors.pod = "POD is required";
    }
    if (getCargoType.length === 0) {
      errors.cargotype = "Cargo type is required";
    }
    if (!GET_COMMODITY.trim()) {
      errors.commodityErr = "Commodity is required";
    }
    if (param_loadtype == "fcl") {
      if (getPriority.length === 0) {
        errors.priority = "Priority is required";
      }
    }
    if (getLoadType.length === 0) {
      errors.loadtype = "Load type is required";
    }
    if (getIncoterm.length === 0) {
      errors.incotermErr = "Incoterms is required";
    }
    if (getCyTerm.length === 0) {
      errors.cyterm = "CY Term is required";
    }
    if (getMBLTerm.length === 0) {
      errors.mblterm = "Master BL Term is required";
    }
    if (getMBLType.length === 0) {
      errors.mbltype = "Master BL type is required";
    }

    if (radioStatus == "EXPORT") {
      if (GET_TRUCKING.length === 0) {
        errors.truckby = "Truck by is required";
      }
      if (GET_AMS_SCAC.length === 0) {
        errors.AMS = "AMS/ACI Filing by is required";
      }
      if (GET_ISF_BY.length === 0) {
        errors.ISF = "ISF Filing by is required";
      }
    }


    if (getShipper.length === 0) {
      errors.shipper = "Customer is required";
    }
    CarrierInputs.map((carritem, key) => {
      if (carritem.CARRIER_CODE == "") {
        errors.carrierError = "Carrier is required";
      }
      if (carritem.SERVICES_CONTRACT == "") {
        if (param_loadtype == "fcl") {
          errors.svcError = "S/C is required";
        } else {
          errors.svcError = "Freight forwarder is required";
        }
      }
      if (carritem.SPECIAL_FLAG == "2" && !carritem.SCAC) {
        errors.remarkError = "Remark is required";
      }
    });

    if (param_loadtype == "lcl") {
      if (!GET_NO_OF_PACK.trim()) {
        errors.GET_NO_OF_PACK_ERR = "Number of package is required";
      } else if (GET_NO_OF_PACK.trim() == 0) {
        errors.GET_NO_OF_PACK_ERR =
          "Number of package value must not be equal to 0";
      }
      if (!GET_PACKAGE_UNIT.trim()) {
        errors.GET_PACKAGE_UNIT_ERR = "Package unit is required";
      }
      if (!GET_CBM.trim()) {
        errors.GET_CBM_ERR = "CBM is required";
      }
      if (!GET_GW.trim()) {
        errors.GET_GW_ERR = "GW is required";
      } else if (GET_GW.trim() == 0) {
        errors.GET_GW_ERR = "GW value must not be equal to 0";
      }
    }
    if (!radioStatus) {
      errors.GET_GW_ERR = "Please select export/import.";
    }





    if (selectedfile.length === 0) {
      //ไม่ได้แนบไฟล์
      //alert("ไม่แนบไฟล์")
      //filesName = "";
    } else {
      //alert("มีแนบไฟล์")
      //check ว่ามีการแนบไฟล์แต่ไม่กดอัพโหลด
      if (checkUplodaFile == false) {
        errors.fileerror = "Please click to upload files";
        //alert("Please click to upload files")
      } else {
        //alert(getFileName)
      }
    }
    return errors;
  };
  const buildContainerPayload = (containers) => ({
    CNT20: containers["20"]?.cnt || "",
    TYPE20: containers["20"]?.type || "",
    GW20: containers["20"]?.gw || "",

    CNT40: containers["40"]?.cnt || "",
    TYPE40: containers["40"]?.type || "",
    GW40: containers["40"]?.gw || "",

    CNT40HQ: containers["40HQ"]?.cnt || "",
    TYPE40HQ: containers["40HQ"]?.type || "",
    GW40HQ: containers["40HQ"]?.gw || "",

    CNT45: containers["45"]?.cnt || "",
    TYPE45: containers["45"]?.type || "",
    GW45: containers["45"]?.gw || "",
  });
  const [selectedKey, setSelectedKey] = useState(null); // container ที่เกิน GW
  const [containerFormError, setContainerFormError] = useState("");
  const [overWeightGW, setOverWeightGW] = useState(null);
  const validateContainerForm = (key, newGW = null) => {
    const errors = {};
    const c = containers[key];
    if (param_loadtype == "lcl") return {};
    // 🔴 CHECK ระดับฟอร์ม: ต้องมี Type อย่างน้อย 1
    const hasAtLeastOneType = Object.values(containers).some((ct) => ct.type);

    if (!hasAtLeastOneType) {
      setContainerFormError("Please select at least one container type");
    } else {
      setContainerFormError("");
    }
    // const gw = newGW !== null ? Number(newGW) : Number(c.gw);

    const gwValue = newGW !== null ? newGW : c.gw;
    const gw = parseFloat(gwValue); // ⭐ รองรับทศนิยม
    // ❌ ยังไม่เลือก Type → ไม่ validate
    if (!c.type) {
      setContainers((prev) => ({
        ...prev,
        [key]: {
          ...prev[key],
          errors: {},
        },
      }));
      return {};
    }

    if (!c.cnt || Number(c.cnt) <= 0) {
      errors.cnt = "Qty is required";
    }

    if (!gw || gw <= 0) {
      errors.gw = "GW is required";
    }

    setContainers((prev) => ({
      ...prev,
      [key]: {
        ...prev[key],
        errors,
      },
    }));

    return errors;
  };
  const isUSPOD = (pod) => {
    return typeof pod === "string" && pod.startsWith("US");
  };
  const checkOverWeightOnBlur = (key) => {
    const c = containers[key];
    if (!c?.type || !c?.gw) return;
    // ✅ เช็ค POD ต้องขึ้นต้นด้วย US เท่านั้น
    if (!isUSPOD(GET_POD)) return;
    const gw = Number(c.gw);
    const limitGW = key === "20" ? 17000 : 19000;

    if (gw > limitGW) {
      setSelectedKey(key);
      setOverWeightGW(gw);
      setOpenModal(true);
    }
  };
  const handleSubmit = (event) => {
    event.preventDefault();
    let hasError = false;
    // 1. validate form หลัก
    const newErrors = validateForm();
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      hasError = true;
    }

    // validate ทุก container
    containerFields.forEach(({ key }) => {
      const err = validateContainerForm(key);
      if (Object.keys(err).length > 0) {
        hasError = true;
      }
    });
    if (containerFormError) {
      hasError = true;
    }
    // 3. logic DOOR
    var last4 = selectCyTerm.slice(-4);
    if (last4 != "DOOR") {
      SET_DOOR_BY("");
    }
    // 4. ถ้ามี error → ไม่ submit
    if (hasError) {
      console.log("❌ Validation failed");
      return;
    }

    // 5. ผ่านทุกอย่าง
    setIsLoading(true);
    SET_OPEN_MODAL(0);
    submitForm();
  };
  // 3️⃣ ฟังก์ชัน submit จริง
  const submitForm = () => {
    const containerPayload = buildContainerPayload(containers);
    let carrierInputsData = [...CarrierInputs];
    let post_url = "";
    let carGoStr;
    let ORDER_ID;
    let filesName;
    if (selectCargoType.length === 0 || getCargoType.length === 0) {
      carGoStr = "";
    } else {
      carGoStr = selectCargoType;
    }
    if (order_id) {
      ORDER_ID = order_id;
    } else {
      ORDER_ID = 0;
    }
    if (files.length === 0) {
      //ไม่ได้แนบไฟล์
      filesName = "";
    } else {
      filesName = getFileName;
    }
    var data = {
      SALES_ID: getSale.SALE_CODE,
      QUOTATION_NO: GET_QUOTATION_NO,
      BOUND_TYPE: GET_BOUND_TYPE,
      JOBOWNER: GET_JOB_OWNER,
      BOOKING_BY: GET_BOOKING_BY,
      SHIPPER_CODE: getShipper.COM_CODE,
      CNEE_CODE: getConsignee.COM_CODE,
      AGENT_CODE: getAgent.COM_CODE,
      SHIPPERLOAD_CODE: getShipperLoad.COM_CODE,
      COLOAD_CODE: getCoload.COM_CODE,
      PARTY_3RD_NAME: GET_PARTY_3RD_NAME,
      CREDIT_TERM: GET_CREDIT_TERM,
      CARGO_READY: getCargoReady,
      CY_DATE: getCyDate,
      RETURN_DATE: getReturnDate,
      ETD_DATE: getEtdDate,
      ETA_DATE: getEtaDate,
      POR: GET_POR,
      POL: GET_POL,
      POD: GET_POD,
      DEL: GET_DEL,
      FINAL: GET_FINAL,
      DOOR_BY: GET_DOOR_BY,
      CARGO_TYPE: carGoStr,
      HSCODE: GET_HSCODE,
      COMMODITY: GET_COMMODITY,
      LOADTYPE: selectLoadType,
      CHGTERMMBL: selectMBLTerm,
      BLTYPEMBL: selectMBLType,
      CHGTERM: selectHBLTerm,
      BLTYPE: selectHBLType,
      INCOTERM: selectIncoterm,
      CYTERM: selectCyTerm,
      SHIPPING: GET_SHIPPING,
      TRUCKING: GET_SELECT_TRUCKBY,
      TRUCKING_REMARK: GET_TRUCKBY_REMARK,
      INSURANCE: GET_INSURANCE,
      SHIPPING_DEL: GET_SHIPPING_DEL,
      TRUCKING_DEL: GET_TRUCKING_DEL,
      AMS_SCAC: SELECT_AMS_SCAC,
      FILING_BY: "",
      ISF_BY: SELECT_ISF_BY,
      AGENT_SALES_EMAIL: GET_AGENT_SALES_EMAIL,
      PREALERT_EMAIL: GET_PREALERT_EMAIL,
      BOOKING_PIC: GET_BOOKING_PIC,
      DOC_PIC: GET_DOC_PIC,
      REMARK_TO_CS: GET_REMARK_TO_CS,
      REMARK_TO_DOC: GET_REMARK_TO_DOC,
      REMARK_TO_ACC: GET_REMARK_TO_ACC,
      ORDER_STATUS: GET_ORDER_STATUS_ID,
      USERID: getCrmId,
      CUSTOMER_REF: GET_CUSTOMER_REF,
      CSID: getCs.CS_ID,
      ATTACHMENT: filesName,
      DG_CLASS: GET_DG_CLASS,
      TEMPERATURE: GET_DG_CLASS,
      HUMIDITY: GET_HUMIDITY,
      PRE_COOL: GET_PRE_COOL,
      VENT: GET_VENT,
      GW: GET_GW,
      NO_OF_PACK: GET_NO_OF_PACK,
      PACKAGE_UNIT: GET_PACKAGE_UNIT,
      CBM: GET_CBM,
      DIMENSION_NOTE: GET_DIMENSION_NOTE,
      WAITING_FLAG: GET_WAITING_FLAG,
      BOOK_PRIORITY_CODE: getPriority.value,
      BOOK_PRIORITY: getPriority.label,
      FINAL_ADDRESS: GET_FINAL_ADDRESS,
      CARRIER_INPUT: carrierInputsData,
      DUPLICATE_ORDER: GET_DUP_ORDER,
      CUSTOMER_CODE: GET_CUSTOMER_CODE,
      PAPERLESS_CODE: GET_PAPERLESS_CODE,
      INVOICE_CHARGE_TO: GET_INVOICE_CHARGE_TO,
      REMARK_TO_REPORT: GET_REMARK_TO_REPORT,
      ORDER_ID: ORDER_ID,
      ...containerPayload,
    };

    console.log("Data to send:", data); // ✅ ดูข้อมูลก่อนส่ง
    if (GET_DUP_ORDER > 1) {
      post_url = "/TS_SALES_ORDER_DUPLICATE.php";
    } else {
      post_url = "/TS_SALES_ORDER.php";
    }
    if (order_id) {
      fetch(api_path + "/TS_SALES_ORDER.php", {
        method: "POST",
        headers: {
          Accept: "application/form-data",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((result) => {
          if (result["status"] == "200") {
            setIsLoading(false);
            swal("Done.", "Update data successfully", "success", {
              buttons: true,
              timer: 5000,
            }).then(function () {
              setButtonDisabled(true);
              setCarrierInputs([]);
              window.location =
                "./SalesOrderDetail?order_id=" + result["message"] + "";
            });
          } else {
            setIsLoading(false);
            swal("Sorry", result["message"], "error", {
              buttons: true,
              timer: 10000,
            });
          }
        });
    } else {
      fetch(api_path + "" + post_url, {
        method: "POST",
        headers: {
          Accept: "application/form-data",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((result) => {
          if (GET_DUP_ORDER == 1) {
            if (result["status"] == "200") {
              swal("Done.", "Save data successfully", "success", {
                buttons: true,
                timer: 5000,
              }).then(function () {
                setButtonDisabled(true);
                setCarrierInputs([]);
                window.location =
                  "./SalesOrderDetail?order_id=" + result["message"] + "";
              });
            } else {
              setIsLoading(false);
              swal("Sorry", result["message"], "error", {
                buttons: true,
                timer: 10000,
              });
            }
          } else if (GET_DUP_ORDER > 1) {
            //dup
            window.location =
              "./SalesOrderDupOrder?duplicateid=" + result["message"] + "";
          } else {
            swal("Sorry", "Error", "error", {
              buttons: true,
              timer: 5000,
            });
          }
        });
    }
  };
  const handleKeyDown = (event, callback) => {
    if (event.key === "Enter" && event.shiftKey === false) {
      event.preventDefault();
    }
  };
  const optionsContainerSize = [
    { value: "20", label: "20" },
    { value: "40", label: "40" },
    { value: "45", label: "45" },
  ];
  const optionsContainerType = [
    { value: "DC", label: "DC" }, //Dry Container
    { value: "FR", label: "FR" }, //Flat Rack Container
    { value: "OT", label: "OT" }, //Open Top Container
    { value: "RF", label: "RF" }, //Reefer Container
    { value: "BULK", label: "BULK" },
    { value: "TANK", label: "TANK" }, //Tank Container
    { value: "HC", label: "HC" },
    { value: "SOC", label: "SOC" },
  ];
  const priorityOptions = [
    { value: "1", label: "Book one carrier (In order)" },
    { value: "2", label: "Book all carriers in the list" },
  ];
  const LCL_ServiceContract_LIST = [
    { value: "SINO", label: "SINO" },
    { value: "CO-LOAD", label: "CO-LOAD" },
  ];
  const optionsLoadType = [
    { value: "FCL", label: "FCL" },
    { value: "CONSOLE", label: "CONSOLE" },
  ];
  const optionsLoadTypeLCL = [{ value: "LCL", label: "LCL" }];
  const optionsBLTerm = [
    { value: "PP", label: "PP" },
    { value: "CC", label: "CC" },
  ];
  const optionsBLType = [
    { value: "ORIGINAL", label: "ORIGINAL" },
    { value: "SURRENDER", label: "SURRENDER" },
    { value: "SEA WAYBILL", label: "SEA WAYBILL" },
    { value: "AS PER SI", label: "AS PER SI" }, //SHIPPING INSTRUCTIONS
  ];
  const [getMBLType, setMBLType] = useState(optionsBLType[0]);
  const optionsChargeTerm = [
    { value: "DOOR/CFS", label: "DOOR/CFS" },
    { value: "CY/CFS", label: "CY/CFS" },
    { value: "DOOR/CY", label: "DOOR/CY" },
    { value: "CFS/DOOR", label: "CFS/DOOR" },
    { value: "CY/CY", label: "CY/CY" },
    { value: "CY-IN/CY", label: "CY-IN/CY" },
    { value: "CFS/CY", label: "CFS/CY" },
    { value: "DOOR/DOOR", label: "DOOR/DOOR" },
    { value: "CY/DOOR", label: "CY/DOOR" },
    { value: "CFS/CFS", label: "CFS/CFS" },
  ];
  const optionsIncoterm = [
    { value: "EXW", label: "EXW" },
    { value: "FCA", label: "FCA" },
    { value: "FAS", label: "FAS" },
    { value: "FOB", label: "FOB" },
    { value: "CFR", label: "CFR" },
    { value: "CIF", label: "CIF" },
    { value: "CPT", label: "CPT" },
    { value: "CIP", label: "CIP" },
    { value: "DAT", label: "DAT" },
    { value: "DAP", label: "DAP" },
    { value: "DDP", label: "DDP" },
    { value: "DPU", label: "DPU" },
    { value: "DDU", label: "DDU" },
  ];
  const optionsCargoType = [
    { value: "FAK", label: "FAK" },
    { value: "FOOD", label: "FOOD" },
    { value: "DG", label: "DG" },
    { value: "REEFER", label: "REEFER" },
    { value: "SOC", label: "SOC" },
    { value: "GARMENT", label: "GARMENT" },
    { value: "NAC", label: "NAC" },
  ];
  const optionsCyTerm = [
    { value: "DOOR/CFS", label: "DOOR/CFS" },
    { value: "CY/CFS", label: "CY/CFS" },
    { value: "DOOR/CY", label: "DOOR/CY" },
    { value: "CFS/DOOR", label: "CFS/DOOR" },
    { value: "CY/CY", label: "CY/CY" },
    { value: "CY-IN/CY", label: "CY-IN/CY" },
    { value: "CFS/CY", label: "CFS/CY" },
    { value: "DOOR/DOOR", label: "DOOR/DOOR" },
    { value: "CY/DOOR", label: "CY/DOOR" },
    { value: "CFS/CFS", label: "CFS/CFS" },
  ];
  const optionsAMS_SCAC = [
    { value: "SINO", label: "SINO" },
    { value: "COLOADER", label: "COLOADER" },
    { value: "CARRIER", label: "CARRIER" },
    { value: "NO", label: "NO" },
  ];
  const optionsISF_BY = [
    { value: "AGENT", label: "AGENT" },
    { value: "CNEE/SHIPPER", label: "CNEE/SHIPPER" },
    { value: "NO", label: "NO" },
  ];
  const optionsTruck_BY = [
    { value: "ICL", label: "ICL" },
    {
      value: "ICL – BILLING THROUGH (SPECIAL CASE WITH APPROVAL)",
      label: "ICL – BILLING THROUGH (SPECIAL CASE WITH APPROVAL)",
    },
    { value: "NOT HANDLE", label: "NOT HANDLE" },
  ];
  const handleAMS_SCACChange = (obj) => {
    SET_SELECT_AMS_SCAC(obj.value);
    SET_AMS_SCAC({
      value: obj.value,
      label: obj.label,
    });
  };
  const handleISF_BYChange = (obj) => {
    SET_SELECT_ISF_BY(obj.value);
    SET_ISF_BY({
      value: obj.value,
      label: obj.label,
    });
  };
  const handleTruckbyChange = (obj) => {
    SET_SELECT_TRUCKBY(obj.value);
    SET_TRUCKING({
      value: obj.value,
      label: obj.label,
    });
  };
  const handlePriorityChange = (obj) => {
    setSelectPriority(obj.value);
    setPriority({
      value: obj.value,
      label: obj.label,
    });
  };
  const handleMBLTermChange = (obj) => {
    setSelectMBLTerm(obj.value);
    setMBLTerm({
      value: obj.value,
      label: obj.label,
    });
  };
  const handleMBLTypeChange = (obj) => {
    setSelectMBLType(obj.value);
    setMBLType({
      value: obj.value,
      label: obj.label,
    });
  };
  const handleHBLTypeChange = (obj) => {
    if (obj) {
      setSelectHBLType(obj.value);
      setHBLType({
        value: obj.value,
        label: obj.label,
      });
    } else {
      setSelectHBLType("");
      setHBLType("");
    }
  };
  const handleHBLTermChange = (obj) => {
    if (obj) {
      setSelectHBLTerm(obj.value);
      setHBLTerm({ value: obj.value, label: obj.label });
    } else {
      setSelectHBLTerm("");
      setHBLTerm("");
    }
  };
  const fetchPort = () => {
    axios
      .get(api_path + `/MS_ISO_PORT.php?GETALLPORT=1`)
      .then((response) => {
        setPorList(response.data);
        setPolList(response.data);
        setPodList(response.data);
        setDelList(response.data);
        setFinalList(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  function updatePortData(SVALUE, PORT_CODE) {
    if (SVALUE == "POL") {
      SET_POL(PORT_CODE);
    }
    if (SVALUE == "POR") {
      SET_POR(PORT_CODE);
    }
    if (SVALUE == "POD") {
      SET_POD(PORT_CODE);
    }
    if (SVALUE == "DEL") {
      SET_DEL(PORT_CODE);
    }
    if (SVALUE == "FINAL") {
      SET_FINAL(PORT_CODE);
    }
  }
  const initialList = [
    {
      CARRIER_INDEX: "",
      CARRIER_ITEM_ID: "",
      CARRIER_CODE: "",
      SERVICES_CONTRACT: "",
      BULLET_CODE: "",
      SCAC: "",
      SC_CONDITION: "",
      SC_VALIDITY: "",
      SPECIAL_FLAG: "",
      BOOKING_REF: "",
      BOOKING_NO: "",
      PROFORMA_ETD: "",
      REMARK: "",
      ACTIVE_STATUS: "",
      STATUS_NAME: "",
      CONTAINER_CUTOFF_DATE: "",
      CONTAINER_CUTOFF_TIME: "",
    },
  ];
  const [CarrierInputs, setCarrierInputs] = useState([]);
  const handleAddInputCarrier = () => {
    setCarrierInputs([
      ...CarrierInputs,
      {
        CARRIER_INDEX: "",
        CARRIER_ITEM_ID: "",
        CARRIER_CODE: "",
        SERVICES_CONTRACT: "",
        BULLET_CODE: "",
        SCAC: "",
        SC_CONDITION: "",
        SC_VALIDITY: "",
        SPECIAL_FLAG: "",
        BOOKING_REF: "",
        BOOKING_NO: "",
        PROFORMA_ETD: "",
        REMARK: "",
        ACTIVE_STATUS: "",
        STATUS_NAME: "",
        CONTAINER_CUTOFF_DATE: "",
        CONTAINER_CUTOFF_TIME: "",
      },
    ]);
  };
  const handleChangeCarrier = (option, index, name) => {
    const value = option.value;
    const list = [...CarrierInputs];
    list[index][name] = value;
    setCarrierInputs(list);
  };

  const handleChangeTextboxCarrier = (event, index) => {
    let { name, value } = event.target;
    let onChangeValue = [...CarrierInputs];
    onChangeValue[index][name] = value;
    setCarrierInputs(onChangeValue);
  };
  const handleDeleteInputCarrier = (index) => {
    let onChangeValue = [...CarrierInputs];
    if (order_id > 0) {
      if (onChangeValue[index]["CARRIER_ITEM_ID"]) {
        //alert("มี carrier")
        const newArray = CarrierInputs.map((item, i) => {
          if (index === i) {
            return {
              ...item,
              ACTIVE_STATUS: 0,
              STATUS_NAME: "INACTIVE",
            };
          } else {
            return item;
          }
        });
        setCarrierInputs(newArray);
      } else {
        //alert("ไม่มี carrier")
        const newArray = [...CarrierInputs];
        newArray.splice(index, 1);
        setCarrierInputs(newArray);
      }
    } else {
      //new
      const newArray = [...CarrierInputs];
      newArray.splice(index, 1);
      setCarrierInputs(newArray);
    }
  };
  const delCarrier = async (id) => {
    try {
      const response = await axios.delete(
        api_path + `/TS_SALES_ORDER.php?order_id=${id}`
      );
      // setLoadGrid(randomNumberInRange(1, 20));
    } catch (error) {
      console.error(error);
    }
  };
  function updateServiceData(
    CARRIER_ID,
    CARRIER,
    SERVICE,
    BULLET,
    SCAC,
    SC_CONDITION,
    SC_VALIDITY,
    SPECIAL_FLAG,
    CARRIER_INDEX
  ) {
    let newArray = CarrierInputs.map((item, i) => {
      if (CARRIER_INDEX === i) {
        return {
          ...item,
          CARRIER_INDEX: CARRIER_INDEX,
          CARRIER_ITEM_ID: CARRIER_ID,
          CARRIER_CODE: CARRIER,
          SERVICES_CONTRACT: SERVICE,
          BULLET_CODE: BULLET,
          SCAC: SCAC,
          SC_CONDITION: SC_CONDITION,
          SC_VALIDITY: SC_VALIDITY,
          SPECIAL_FLAG: SPECIAL_FLAG,
          ACTIVE_STATUS: "1",
          STATUS_NAME: "ACTIVE",
        };
      } else {
        return item;
      }
    });
    setCarrierInputs(newArray);
  }
  function updateCarrier(CARRIER_ITEM_ID, CARRIER_CODE, CARR_INDEX) {
    SET_OPEN_MODAL(1);
    const newArray = CarrierInputs.map((item, i) => {
      if (CARR_INDEX === i) {
        return {
          ...item,
          CARRIER_ITEM_ID: CARRIER_ITEM_ID,
          CARRIER_CODE: CARRIER_CODE,
          SERVICES_CONTRACT: "",
        };
      } else {
        return item;
      }
    });
    setCarrierInputs(newArray);
  }
  function update_LCL_ServiceContract(SERVICES_CONTRACT, CARR_INDEX) {
    const newArray = CarrierInputs.map((item, i) => {
      if (CARR_INDEX === i) {
        return { ...item, SERVICES_CONTRACT: SERVICES_CONTRACT };
      } else {
        return item;
      }
    });
    setCarrierInputs(newArray);
  }

  const handleAddInputContainer = () => {
    setContainerInputs([
      ...containerInputs,
      {
        CTNR_ITEM_ID: "",
        CTNR_SIZE: "",
        CTNR_TYPE: "",
        CTNR_QTY: "",
        CTNR_UNIT: "",
        CTNR_CBM: "",
        GW: "",
        CTNR_REMARK: "",
      },
    ]);
  };
  const handleChangeTextboxContainer = (event, index) => {
    let { name, value } = event.target;
    let onChangeValue = [...containerInputs];
    onChangeValue[index][name] = value;
    setContainerInputs(onChangeValue);
  };
  const handleDeleteInputContainer = (index) => {
    const newArray = [...containerInputs];
    newArray.splice(index, 1);
    setContainerInputs(newArray);
  };
  const fetchCarrier = () => {
    axios
      .get(api_path + `/MS_CARRIER.php?LOADTYPE=` + param_loadtype)
      .then((response) => {
        setCarrierList(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const fetchSale = () => {
    axios
      .get(
        api_path + `/GET_SALES.php?role=` + getUserRole + `&user=` + getCrmId
      )
      .then((response) => {
        setSaleList(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleSaleChange = (obj) => {
    setSelectSale(obj.SALE_CODE);
    setSale({ SALE_CODE: obj.SALE_CODE, SALE_NAME: obj.SALE_NAME });
    setSaleAuthenCode(obj.SALE_CODE);
  };
  const fetchCS = () => {
    axios
      .get(api_path + `/GET_CS.php?role=` + getUserRole + `&user=` + getCrmId)
      .then((response) => {
        setCsList(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleCsChange = (obj) => {
    setSelectCs(obj.CS_ID);
    setCs({ CS_ID: obj.CS_ID, CS_EMAIL: obj.CS_EMAIL });
  };
  useEffect(() => {
    const getShipperDropdown = async () => {
      const resstate = await fetch(
        api_path +
        `/TMP_SMBUSINESS.php?SALES_CODE=${getSaleAuthenCode}&TYPE=SHIPPER`
      );
      const getst = resstate.json();
      setShipperList(await getst);
    };
    getShipperDropdown().then();
  }, [getSale]);
  const handleShipperChange = (obj) => {
    setSelectShipper(obj.COM_CODE);
    setShipper({
      COM_CODE: obj.COM_CODE,
      COM_NAME: obj.COM_NAME,
    });
  };
  useEffect(() => {
    const getCNEEDropdown = async () => {
      const resstate = await fetch(
        api_path +
        `/TMP_SMBUSINESS.php?SALES_CODE=${getSaleAuthenCode}&TYPE=CONSIGNEE`
      );
      const getst = resstate.json();
      setConsigneeList(await getst);
    };
    getCNEEDropdown().then();
  }, [getSale]);
  const handleConsigneeChange = (obj) => {
    if (obj) {
      setSelectConsignee(obj.COM_CODE);
      setConsignee({
        COM_CODE: obj.COM_CODE,
        COM_NAME: obj.COM_NAME,
      });
    } else {
      setSelectConsignee([]);
      setConsignee([]);
    }
  };
  useEffect(() => {
    const getAgentDropdown = async () => {
      const resstate = await fetch(
        api_path +
        `/TMP_SMBUSINESS.php?SALES_CODE=${getSaleAuthenCode}&TYPE=AGENT`
      );
      const getst = resstate.json();
      setAgentList(await getst);
    };
    getAgentDropdown().then();
  }, [getSale]);
  const handleAgentChange = (obj) => {
    if (obj) {
      setSelectAgent(obj.COM_CODE);
      setAgent({
        COM_CODE: obj.COM_CODE,
        COM_NAME: obj.COM_NAME,
      });
    } else {
      setSelectAgent([]);
      setAgent([]);
    }
  };
  useEffect(() => {
    const getShipperLoadDropdown = async () => {
      const resstate = await fetch(
        api_path +
        `/TMP_SMBUSINESS.php?SALES_CODE=${getSaleAuthenCode}&TYPE=SHIPPERLOAD`
      );
      const getst = resstate.json();
      setShipperLoadList(await getst);
    };
    getShipperLoadDropdown().then();
  }, [getSale]);
  const handleShipperLoadChange = (obj) => {
    if (obj) {
      setSelectShipperLoad(obj.COM_CODE);
      setShipperLoad({
        COM_CODE: obj.COM_CODE,
        COM_NAME: obj.COM_NAME,
      });
    } else {
      setSelectShipperLoad([]);
      setShipperLoad([]);
    }
  };
  useEffect(() => {
    const getColoadLoadDropdown = async () => {
      const resstate = await fetch(
        api_path +
        `/TMP_SMBUSINESS.php?SALES_CODE=${getSaleAuthenCode}&TYPE=COLOAD`
      );
      const getst = resstate.json();
      setColoadList(await getst);
    };
    getColoadLoadDropdown().then();
  }, [getSale]);
  const handleColoadChange = (obj) => {
    if (obj) {
      setSelectCoload(obj.COM_CODE);
      setCoload({
        COM_CODE: obj.COM_CODE,
        COM_NAME: obj.COM_NAME,
      });
    } else {
      setSelectCoload([]);
      setCoload([]);
    }
  };
  const handleLoadTypeChange = (obj) => {
    setSelectLoadType(obj.value);
    setLoadType({ value: obj.value, label: obj.label });
  };
  const [getRequire, setRequire] = useState();
  const handleCargoTypeChange = (obj) => {
    if (obj) {
      setSelectCargoType(obj.value);
      setCargoType({ value: obj.value, label: obj.label });
      if (obj.value == "DG") {
        // if (obj.value == "DG") {
        //   SET_DG_TEXT("DG CLASS/UN NO:");
        // } else {
        //   SET_DG_TEXT("TEMPERATURE");
        // }

        setRequire("required");
        setShowDG(true);
        setShowReefer(false);
      } else if (obj.value == "REEFER") {
        setShowReefer(true);
        setShowDG(false);
      } else {
        setRequire("");
        setShowReefer(false);
        setShowDG(false);
      }
    } else {
      setSelectCargoType([]);
      setCargoType([]);
    }
  };
  const handleIncotermChange = (obj) => {
    if (obj) {
      setSelectIncoterm(obj.value);
      setIncoterm({ value: obj.value, label: obj.label });
    } else {
      setSelectIncoterm([]);
      setIncoterm([]);
    }
  };
  const handleCyTermChange = (obj) => {
    setSelectCyTerm(obj.value);
    setCyTerm({ value: obj.value, label: obj.label });
    var last4 = obj.value.slice(-4);
    if (last4 == "DOOR") {
      setShowDoorBy(true);
    } else {
      setShowDoorBy(false);
    }
  };
  const fetchCarrierData = async (order_id) => {
    const response = await fetch(
      api_path + "/TS_SALES_ORDER_ITEM.php?order_id=" + order_id + "&flag=1"
    );
    const data = await response.json();
    setCarrierInputs(data);
  };
  const isCheckedProcool = (value) => radioStatusPrecool === value;
  const [radioStatusPrecool, setRadioStatusPrecool] = useState("N");
  const handleRadioChangePreCool = (event) => {
    setRadioStatusPrecool(event.target.value);
    if (event.target.value == "Y") {
      SET_PRE_COOL("Y");
    } else if (event.target.value == "N") {
      SET_PRE_COOL("N");
    }
  };
  const isCheckedWaitingFlag = (value) => radioStatusWaitingFlag === value;
  const [radioStatusWaitingFlag, setRadioStatusWaitingFlag] = useState("N");
  const handleRadioChangeWaitingFlag = (event) => {
    setRadioStatusWaitingFlag(event.target.value);
    if (event.target.value == "Y") {
      SET_WAITING_FLAG("Y");
    } else if (event.target.value == "N") {
      SET_WAITING_FLAG("N");
    }
  };
  const isChecked = (value) => radioStatus === value;
  const [radioStatus, setRadioStatus] = useState("EXPORT");
  const [radioResponse, setRadioResponse] = useState();
  const handleRadioChangeBoundType = (event) => {
    setRadioStatus(event.target.value);
    if (event.target.value == "EXPORT") {
      SET_BOUND_TYPE("EXPORT");
    } else if (event.target.value == "IMPORT") {
      SET_BOUND_TYPE("IMPORT");
    }
  };

  const isCheckedSoldBy = (value) => radioStatusSoldBy === value;
  const [radioResponseSoldBy, setRadioResponseSoldBy] = useState();
  const handleRadioChangeSoldBy = (event) => {
    setRadioStatusSoldBy(event.target.value);
    if (event.target.value == "FREEHAND") {
      SET_JOB_OWNER("FREEHAND");
    } else if (event.target.value == "NOMINATE") {
      SET_JOB_OWNER("NOMINATE");
    }
  };
  const isCheckedBookingBy = (value) => radioStatusBookingBy === value;
  const [radioStatusBookingBy, setRadioStatusBookingBy] = useState("SINO");
  const [radioResponseBookingby, setRadioResponseBookingBy] = useState();
  const handleRadioChangeBookingBy = (event) => {
    setRadioStatusBookingBy(event.target.value);
    if (event.target.value == "SINO") {
      SET_BOOKING_BY("SINO");
    } else if (event.target.value == "AGENT") {
      SET_BOOKING_BY("AGENT");
    }
  };
  const isCheckedDoorBy = (value) => radioStatusDoorBy === value;
  const [radioStatusDoorBy, setRadioStatusDoorBy] = useState("AGENT");
  const [radioResponseDoorBy, setRadioResponseDoorBy] = useState();
  const handleRadioChangeDoorBy = (event) => {
    setRadioStatusDoorBy(event.target.value);
    if (event.target.value == "AGENT") {
      SET_DOOR_BY("AGENT");
    } else if (event.target.value == "CARRIER") {
      SET_DOOR_BY("CARRIER");
    }
  };
  const isCheckedCusCode = (value) => getRadioCuscode === value;
  const [getRadioCuscode, setRadioCuscode] = useState("NO"); // ค่า default
  const handleRadioChangeCusCode = (event) => {
    setRadioCuscode(event.target.value);
    if (event.target.value == "YES") {
      SET_CUSTOMER_CODE_FLAG("YES");
    } else if (event.target.value == "NO") {
      SET_CUSTOMER_CODE_FLAG("NO");
    }
  };
  const isCheckedRadioPaperless = (value) => getRadioPaperless === value;
  const [getRadioPaperless, setRadioPaperless] = useState("NO"); // ค่า default
  const handleRadioChangePaperless = (event) => {
    setRadioPaperless(event.target.value);
    if (event.target.value == "YES") {
      SET_PAPERLESS_CODE_FLAG("YES");
    } else if (event.target.value == "NO") {
      SET_PAPERLESS_CODE_FLAG("NO");
    }
  };
  //upload file//
  const [files, setFiles] = useState([]);
  const [getFileName, setFileName] = useState([]);
  const [selectedfile, SetSelectedFile] = useState([]);
  const filesizes = (bytes, decimals = 2) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  };
  const InputChange = (e) => {
    setShowUploadMsg("⚠️ Pressing the Upload button.");
    const selectedFiles = Array.from(e.target.files);
    var totalSize = 0;
    for (let i = 0; i < e.target.files.length; i++) {
      const file = selectedFiles[i];
      SetSelectedFile((preValue) => {
        return [
          ...preValue,
          {
            id: i,
            filename: e.target.files[i].name,
            filetype: e.target.files[i].type,
            filesize: filesizes(e.target.files[i].size),
          },
        ];
      });
      if (file) {
        totalSize += parseInt(file.size);
      }
    }
    const maxSize = 30 * 1024 * 1024; // 30MB
    if (totalSize > maxSize) {
      setErrorMessage("File size exceeds. It should be less than 30MB.");
      setShowUploadMsg("");
    } else {
      const isAllowedFiles = checkIsAllowedType(selectedFiles);
      if (!isAllowedFiles) {
        setErrorMessage(
          "Please select file jpg, jpeg, png, gif, pdf, doc ,docx, xls, xlsx, csv ."
        );
        setShowUploadMsg("");
      } else {
        setErrorMessage("");
        const commaString = selectedFiles
          .map((item) => GET_RANDOM_KEY + "_" + item.name)
          .join(",");
        setFileName(commaString.replaceAll(" ", ""));
        setFiles(selectedFiles);
      }
    }
  };
  const handleFileUpload = async () => {
    if (files.length === 0) {
      setErrorMessage("Please select atleast a file to upload.");
      setShowUploadMsg("");
      return;
    }
    setErrorMessage("");
    handleMultipleFileUploadAjax(files);
  };
  async function handleMultipleFileUploadAjax(files) {
    try {
      const formData = new FormData();
      let newName;
      for (let i = 0; i < files.length; i++) {
        newName = GET_RANDOM_KEY + "_" + files[i].name;
        formData.append("file[]", files[i], newName.replaceAll(" ", ""));
      }

      formData.append("dirname", order_id);
      const response = await axios.post(
        api_path + "/SALEORDER_UPLOAD.php",
        formData,
        {
          onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
          },
        }
      );
      if (response.data.status == "200") {
        setShowUploadMsg("✅ Uploaded successfully!");
        setUplodaFile(true);
      } else {
        setShowUploadMsg("❌ Upload failed!" + response.data.message);
        setFiles([]);
        setFileName([]);
        setUplodaFile(false);
      }
    } catch (error) {
      setShowUploadMsg("❌ Upload failed!");
      console.error(error);
      setFiles([]);
      setFileName([]);
      setUplodaFile(false);
    }
  }
  const DeleteSelectFile = (id, index) => {
    if (window.confirm("Are you sure you want to delete this file?")) {
      const result = selectedfile.filter((data) => data.id !== id);
      SetSelectedFile(result);
      setFiles(result);
    } else {
      alert("Can not delete this file");
    }
  };
  const DeleteFile = async (id, index) => {
    if (window.confirm("Are you sure you want to delete this file?")) {
      const result = files.filter((data) => data.id !== id);
      setFiles(result);
    } else {
      alert("Can not delete file.");
    }
  };
  const [errorMessage, setErrorMessage] = useState("");
  function checkIsAllowedType(selectedFiles) {
    const allowedTypes = [
      ".jpg",
      ".jpeg",
      ".png",
      ".gif",
      ".pdf",
      ".doc",
      ".docx",
      ".xls",
      ".xlsx",
      ".csv",
    ];
    return selectedFiles.some((file) => {
      const fileExtension = file.name.split(".").pop().toLowerCase();
      return allowedTypes.includes(`.${fileExtension}`);
    });
  }
  function readableBytes(bytes) {
    var i = Math.floor(Math.log(bytes) / Math.log(1024)),
      sizes = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    return (bytes / Math.pow(1024, 2)).toFixed(2) * 1 + " " + sizes[2];
  }
  const [getAttachment, setAttachment] = useState("");
  const splitedStr = getAttachment.split(",");
  var returnStr = "";
  for (var i = 0; i < splitedStr.length; i++) {
    returnStr +=
      '<p><a href="https://apps.sinologistics.co.th/api/uploads/sales_order_local/' +
      splitedStr[i] +
      '" target="_blank">' +
      splitedStr[i] +
      "</a></p>";
  }
  function updateContainerSize(CTNR_SIZE, CTNR_INDEX) {
    const newArray = containerInputs.map((item, i) => {
      if (CTNR_INDEX === i) {
        return { ...item, CTNR_SIZE: CTNR_SIZE };
      } else {
        return item;
      }
    });
    setContainerInputs(newArray);
  }
  function updateContainerType(CTNR_TYPE, CTNR_INDEX) {
    const newArray = containerInputs.map((item, i) => {
      if (CTNR_INDEX === i) {
        return { ...item, CTNR_TYPE: CTNR_TYPE };
      } else {
        return item;
      }
    });
    setContainerInputs(newArray);
  }
  const editorRef = React.useRef();
  const editorRef2 = React.useRef();
  const editorRef3 = React.useRef();
  const editorRef4 = React.useRef();
  const [getValue, setValue] = React.useState("1");
  const [renderEditor, setRenderEditor] = useState(false);
  const handleChangeTab = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);

    [editorRef, editorRef2, editorRef3, editorRef4].forEach((ref) => {
      if (ref.current) {
        ref.current.save();
      }
    });
    SET_OPEN_MODAL(0);
  };
  useEffect(() => {
    if (getValue == "3") {
      // หน่วงเวลาให้ Tab เปลี่ยนเสร็จก่อน 200ms
      const timer = setTimeout(() => {
        setRenderEditor(true);
      }, 200);
      return () => clearTimeout(timer);
    } else {
      setRenderEditor(false); // ปิด Editor เมื่อออกจาก Tab เพื่อคืน Memory
    }
  }, [getValue]);
  const filterOptions = createFilterOptions({
    ignoreCase: true,
    matchFrom: "any",
    limit: 500,
    stringify: (option: FilmOptionType) => option.label,
  });
  const STYLES = {
    "&.MuiAutocomplete-hasPopupIcon.MuiAutocomplete-hasClearIcon .MuiAutocomplete-inputRoot":
    {
      padding: "3px !important",
      fontSize: "14px",
      color: "#000000",
    },
    "&.MuiAutocomplete-root": {
      padding: "0px",
    },
  };
  const [initialData, setInitialData] = useState("");
  let options = {
    entityStyleFn: (entity) => {
      const entityType = entity.get("type").toLowerCase();
      if (entityType === "image") {
        const data = entity.getData();
        return {
          element: "img",
          attributes: {
            src: data.src,
          },
          style: {
            // Put styles here...
          },
        };
      }
    },
  };
  const saveCommentData = (value) => {
    //setInitialData(value);
    SET_CONTENT(value);
    // stateToHTML(value.getCurrentContent());
    // setInitialData(stateToHTML(value.getCurrentContent()));
    // SET_DIMENSION_NOTE(stateToHTML(value.getCurrentContent()));
    // swal({
    //   title: "Done...",
    //   text: "Save dimension note successfully.",
    //   icon: "success",
    // });
  };
  const getHTMLData = (value) => {
    stateToHTML(value.getCurrentContent());
    SET_DIMENSION_NOTE(stateToHTML(value.getCurrentContent()));
  };
  const getData = () => {
    console.log("Initial data ", initialData);
  };
  const myTheme = createTheme({
    overrides: {
      MUIRichTextEditor: {
        root: {
          backgroundColor: "#ebebeb",
        },
        container: {
          display: "flex",
          flexDirection: "column-reverse",
        },
        editor: {
          backgroundColor: "#ebebeb",
          paddingLeft: 5,
        },
        toolbar: {
          borderTop: "1px solid gray",
          backgroundColor: "#ebebeb",
          paddingTop: "5px",
        },
        placeHolder: {
          backgroundColor: "#ebebeb",
          paddingLeft: 5,
          width: "inherit",
          height: " 100px",
          maxHeight: "100px",
        },
        anchorLink: {
          color: "#333333",
          textDecoration: "underline",
        },
        button: {
          padding: "5px",
        },
      },
    },
  });
  if (isLoading) {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          background: "#FFFFFF",
          fontSize: "24px",
          fontWeight: "bold",
          position: "absolute",
          top: "50%",
          left: "50%",
        }}
      >
        Please waiting <br />
        <OrbitProgress variant="track-disc" color="crimson" size="small" />
        {console.log("loading...")}
      </div>
    );
  }
  return (
    <Container maxWidth="lg" className="BorderBox">
      <BseData
        TYPE={type}
        LOADTYPE={param_loadtype}
        SALES_CODE={getEmpCode}
        SALES_NAME={getUserEmail}
        ROLE={getUserRole}
        CRM_ID={getCrmId}
      />
      <OverweightModal
        open={openModal}
        weight={overWeightGW} // ✅ GW ที่เกินจริง
        onConfirm={() => {
          setOpenModal(false);
          //submitForm(); // OK → submit
        }}
        onCancel={() => setOpenModal(false)} // Cancel → ปิด modal
      />
      <Grid container spacing={2}>
        <label className="head">{subjectName}</label>
      </Grid>
      <form
        onSubmit={handleSubmit}
        onKeyDown={(e) => {
          handleKeyDown(e, handleSubmit);
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} sm={3}>
            <label>Request by</label>
            <p>{GET_USER_EMAIL}</p>
          </Grid>
          <Grid item xs={12} sm={3}>
            <label>Request Date</label>
            <p>{GET_ORDER_DATE}</p>
          </Grid>
          {showOrderNo && (
            <Grid item xs={12} sm={3}>
              <label>ORDER NO.</label>
              <p>{GET_ORDER_NO}</p>
            </Grid>
          )}
          {showOrderNo && (
            <Grid item xs={12} sm={3}>
              <label>ORDER STATUS</label>
              <p className={`status${GET_ORDER_STATUS_ID}`}>
                {GET_ORDER_STATUS_NAME}
              </p>
            </Grid>
          )}
          {!showOrderNo && (
            <Grid item xs={12} sm={6}>
              &nbsp;
            </Grid>
          )}
          <Grid item xs={12} sm={3}>
            <label>QUOTATION NO</label>
            <span className="required">*</span>
            <TextField
              size="small"
              name="GET_QUOTATION_NO"
              variant="outlined"
              fullWidth
              id="GET_QUOTATION_NO"
              value={GET_QUOTATION_NO}
              onChange={(e) => SET_QUOTATION_NO(e.target.value)}
            //required
            />
            {errors.quotation && (
              <span className="error-message">{errors.quotation}</span>
            )}
          </Grid>
          <Grid item xs={12} sm={3}>
            <label>CUSTOMER REF</label>
            <TextField
              size="small"
              name="GET_CUSTOMER_REF"
              variant="outlined"
              fullWidth
              id="GET_CUSTOMER_REF"
              value={GET_CUSTOMER_REF}
              onChange={(e) => SET_CUSTOMER_REF(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <label>SALES</label>
            <span className="red">*</span>
            <Select
              placeholder="Select..."
              value={getSale}
              options={saleList}
              onChange={handleSaleChange}
              getOptionLabel={(x) => x.SALE_NAME}
              getOptionValue={(x) => x.SALE_CODE}
            //required
            />
            {errors.getSaleError && (
              <span className="error-message">{errors.getSaleError}</span>
            )}
          </Grid>
          <Grid item xs={12} sm={3}>
            <label>CS</label>
            <span className="red">*</span>
            <Select
              styles={{
                menu: (provided) => ({ ...provided, zIndex: 9999 }),
              }}
              placeholder="Select..."
              value={getCs}
              options={csList}
              onChange={handleCsChange}
              getOptionLabel={(x) => x.CS_EMAIL}
              getOptionValue={(x) => x.CS_ID}
            //required
            />
            {errors.getCsError && (
              <span className="error-message">{errors.getCsError}</span>
            )}
          </Grid>
        </Grid>
        <Box sx={{ width: "100%", typography: "body1" }}>
          <ThemeProvider theme={myTheme}>
            <TabContext value={getValue}>
              <Box
                sx={{
                  borderBottom: 3,
                  borderColor: "rgb(0, 120, 212)",
                  paddingTop: 1,
                }}
              >
                <TabList
                  onChange={handleChangeTab}
                  sx={{
                    "& .Mui-selected": {
                      backgroundColor: "rgb(0, 120, 212)",
                      color: "white",
                      " &.css-3gr6th-MuiButtonBase-root-MuiTab-root.Mui-selected":
                        { color: "white" },
                      " &.css-t373k1.Mui-selected": { color: "white" },
                    },
                  }}
                >
                  <Tab label="Carrier & Container" value="1" />
                  <Tab label="Shipment Details" value="2" />
                  <Tab label="Parties & Contact" value="3" />
                </TabList>
              </Box>

              <TabPanel value="1" keepMounted>
                {/* tab 1 */}

                <Grid container spacing={1}>
                  <Grid item xs={12} sm={3}>
                    <label>BOUND TYPE</label>
                    <br />
                    <RadioButton
                      id="EXPORT"
                      name="EXPORT"
                      value="EXPORT"
                      text="EXPORT"
                      onChange={handleRadioChangeBoundType}
                      checked={isChecked("EXPORT")}
                    />
                    <RadioButton
                      id="IMPORT"
                      name="IMPORT"
                      value="IMPORT"
                      text="IMPORT"
                      onChange={handleRadioChangeBoundType}
                      checked={isChecked("IMPORT")}
                    />
                  </Grid>
                  <Grid item xs={12} sm={3}>
                    <label>SOLD BY</label>
                    <br />
                    <RadioButton
                      id="FREEHAND"
                      name="FREEHAND"
                      value="FREEHAND"
                      text="FREEHAND"
                      onChange={handleRadioChangeSoldBy}
                      checked={isCheckedSoldBy("FREEHAND")}
                    />
                    <RadioButton
                      id="NOMINATE"
                      name="NOMINATE"
                      value="NOMINATE"
                      text="NOMINATE"
                      onChange={handleRadioChangeSoldBy}
                      checked={isCheckedSoldBy("NOMINATE")}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <label>BOOKING BY</label>
                    <br />
                    <RadioButton
                      id="bookbySINO"
                      name="SINO"
                      value="SINO"
                      text="SINO"
                      onChange={handleRadioChangeBookingBy}
                      checked={isCheckedBookingBy("SINO")}
                    />
                    <RadioButton
                      id="bookbyAGENT"
                      name="AGENT"
                      value="AGENT"
                      text="AGENT"
                      onChange={handleRadioChangeBookingBy}
                      checked={isCheckedBookingBy("AGENT")}
                    />
                    <RadioButton
                      id="bookbySINOAGENT"
                      name="SINOAGENT"
                      value="SINOAGENT"
                      text="SINO/AGENT"
                      onChange={handleRadioChangeBookingBy}
                      checked={isCheckedBookingBy("SINOAGENT")}
                    />
                  </Grid>
                  <Grid item xs={12} sm={3}>
                    <label>CUSTOMER CODE</label>
                    <br />
                    {/* <RadioButton
                    id="getRadioCuscodeYes"
                    name="getRadioCuscode"
                    value="YES"
                    text="YES"
                    onChange={handleRadioChangeCusCode}
                    checked={isCheckedCusCode("YES")}
                  />
                  <RadioButton
                    id="getRadioCuscodeNo"
                    name="getRadioCuscode"
                    value="NO"
                    text="NO"
                    onChange={handleRadioChangeCusCode}
                    checked={isCheckedCusCode("NO")}
                  /> */}
                    <TextField
                      size="small"
                      name="GET_CUSTOMER_CODE"
                      variant="outlined"
                      fullWidth
                      id="GET_CUSTOMER_CODE"
                      value={GET_CUSTOMER_CODE}
                      onChange={(e) => SET_CUSTOMER_CODE(e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={3}>
                    <label>Paperless code with customs broker </label>
                    <br />
                    {/* <RadioButton
                    id="getRadioPaperlessYes"
                    name="getRadioPaperless"
                    value="YES"
                    text="YES"
                    onChange={handleRadioChangePaperless}
                    checked={isCheckedRadioPaperless("YES")}
                  />
                  <RadioButton
                    id="getRadioPaperlessNo"
                    name="getRadioPaperless"
                    value="NO"
                    text="NO"
                    onChange={handleRadioChangePaperless}
                    checked={isCheckedRadioPaperless("NO")}
                  /> */}
                    <TextField
                      size="small"
                      name="GET_PAPERLESS_CODE"
                      variant="outlined"
                      fullWidth
                      id="GET_PAPERLESS_CODE"
                      value={GET_PAPERLESS_CODE}
                      onChange={(e) => SET_PAPERLESS_CODE(e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={3}>
                    <label>invoice local charge to </label>
                    <br />
                    <TextField
                      size="small"
                      name="GET_INVOICE_CHARGE_TO"
                      variant="outlined"
                      fullWidth
                      id="GET_INVOICE_CHARGE_TO"
                      value={GET_INVOICE_CHARGE_TO}
                      onChange={(e) => SET_INVOICE_CHARGE_TO(e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={3}></Grid>
                  {/* <Grid item xs={12} sm={3}>
                       <TextField
                      size="small"
                      name="GET_INVOICE_CHARGE_TO"
                      variant="outlined"
                      fullWidth
                      id="GET_INVOICE_CHARGE_TO"
                      value={GET_INVOICE_CHARGE_TO}
                      onChange={(e) => SET_INVOICE_CHARGE_TO(e.target.value)}
                      required
                    />
                  </Grid>
                              <Grid item xs={12} sm={3}>
                                   <TextField
                      size="small"
                      name="GET_INVOICE_CHARGE_TO"
                      variant="outlined"
                      fullWidth
                      id="GET_INVOICE_CHARGE_TO"
                      value={GET_INVOICE_CHARGE_TO}
                      onChange={(e) => SET_INVOICE_CHARGE_TO(e.target.value)}
                      required
                    />
                              </Grid>
                                          <Grid item xs={12} sm={3}></Grid>
                                                      <Grid item xs={12} sm={3}></Grid> */}
                  <Grid item xs={12} sm={2}>
                    <label>CARGO READY</label>
                    <DateBox
                      styles={{
                        menu: (provided) => ({ ...provided, zIndex: 9999 }),
                      }}
                      inputAttr={dateLabel}
                      type="date"
                      displayFormat="dd/MM/yyyy"
                      value={getCargoReady}
                      onValueChanged={onValueChangedCargoReady}
                    />
                  </Grid>
                  <Grid item xs={12} sm={2}>
                    <label>CY DATE</label>
                    <DateBox
                      styles={{
                        menu: (provided) => ({ ...provided, zIndex: 9999 }),
                      }}
                      inputAttr={dateLabel}
                      type="date"
                      displayFormat="dd/MM/yyyy"
                      value={getCyDate}
                      onValueChanged={onValueChangedCyDate}
                    />
                  </Grid>
                  <Grid item xs={12} sm={2}>
                    <label>RETURN DATE</label>
                    <DateBox
                      styles={{
                        menu: (provided) => ({ ...provided, zIndex: 9999 }),
                      }}
                      inputAttr={dateLabel}
                      type="date"
                      displayFormat="dd/MM/yyyy"
                      value={getReturnDate}
                      onValueChanged={onValueChangedReturnDate}
                    />
                  </Grid>
                  <Grid item xs={12} sm={2}>
                    <label>ETD DATE</label>

                    <DateBox
                      styles={{
                        menu: (provided) => ({ ...provided, zIndex: 9999 }),
                      }}
                      //hint="ESTIMATE TIME OF DEPARTURE = ประมาณการของวันที่ที่เรือจะออกจากท่าต้นทาง"
                      inputAttr={dateLabel}
                      type="date"
                      displayFormat="dd/MM/yyyy"
                      value={getEtdDate}
                      onValueChanged={onValueChangedEtdDate}
                    />
                  </Grid>
                  <Grid item xs={12} sm={2}>
                    <label>ETA DATE</label>
                    <DateBox
                      styles={{
                        menu: (provided) => ({ ...provided, zIndex: 9999 }),
                      }}
                      //hint="ESTIMATE TIME OF ARRIVAL = ประมาณการของวันที่ที่เรือจะเข้าถึงท่าปลายทาง"
                      inputAttr={dateLabel}
                      type="date"
                      displayFormat="dd/MM/yyyy"
                      value={getEtaDate}
                      onValueChanged={onValueChangedEtaDate}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    {errors.etdDate && (
                      <span className="error-message">{errors.etdDate}</span>
                    )}
                  </Grid>
                  <Grid container spacing={1}>
                    <Grid item xs={12} sm={2}>
                      <label>POR</label>
                      <span className="red">*</span>
                      <Tooltip
                        title="PLACE OF RECEIPT/สถานที่รับสินค้าต้นทาง"
                        placement="top-end"
                        arrow
                      >
                        <Autocomplete
                          id="free-solo-demo"
                          popupIcon={""}
                          por
                          value={GET_POR}
                          options={porList}
                          filterOptions={filterOptions}
                          renderInput={(params) => (
                            <TextField {...params} variant="outlined" fullWidth />
                          )}
                          onChange={(event, newValue) => {
                            if (newValue) {
                              SET_POR(newValue.value);
                            } else {
                              SET_POR("");
                            }
                          }}
                        // sx={{
                        //   Height: "20px",
                        //   ...STYLES,
                        // }}
                        />
                      </Tooltip>
                      {errors.por && (
                        <span className="error-message">{errors.por}</span>
                      )}
                    </Grid>

                    <Grid item xs={12} sm={2}>
                      <label>POL</label>
                      <span className="red">*</span>
                      <Tooltip
                        title="PLACE OF LOADING/สถานที่ต้นทางที่ส่งออก"
                        placement="top-end"
                        arrow
                      >
                        <Autocomplete
                          id="free-solo-demo"
                          popupIcon={""}
                          pol
                          value={GET_POL}
                          options={polList}
                          onChange={(event, newValue) => {
                            if (newValue) {
                              SET_POL(newValue.value);
                            } else {
                              SET_POL("");
                            }
                          }}
                          renderInput={(params) => (
                            <TextField {...params} variant="outlined" fullWidth />
                          )}
                          filterOptions={filterOptions}
                        />
                      </Tooltip>
                      {errors.pol && (
                        <span className="error-message">{errors.pol}</span>
                      )}
                    </Grid>

                    <Grid item xs={12} sm={2}>
                      <label>POD</label>
                      <span className="red">*</span>
                      <Tooltip
                        title="PLACE OF DELIVERY/สถานที่สุดท้ายที่จะส่งมอบสินค้าให้แก่ผู้ซื้อ"
                        placement="top-end"
                        arrow
                      >
                        <Autocomplete
                          id="free-solo-demo"
                          popupIcon={""}
                          pod
                          value={GET_POD}
                          options={podList}
                          onChange={(event, newValue) => {
                            if (newValue) {
                              SET_POD(newValue.value);
                            } else {
                              SET_POD("");
                            }
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="outlined"
                              fullWidth
                              maxSize="10"
                            />
                          )}
                          filterOptions={filterOptions}
                        />
                      </Tooltip>
                      {errors.pod && (
                        <span className="error-message">{errors.pod}</span>
                      )}
                    </Grid>
                    <Grid item xs={12} sm={2}>
                      <label>DEL</label>
                      <Tooltip title="" placement="top-end" arrow>
                        <Autocomplete
                          popupIcon={""}
                          freeSolo={false}
                          del
                          value={GET_DEL}
                          options={delList}
                          onChange={(event, newValue) => {
                            if (newValue) {
                              SET_DEL(newValue.value);
                            } else {
                              SET_DEL("");
                            }
                          }}
                          renderInput={(params) => (
                            <TextField {...params} variant="outlined" fullWidth />
                          )}
                          filterOptions={filterOptions}
                        />
                      </Tooltip>
                    </Grid>
                    <Grid item xs={12} sm={2}>
                      <label>FINAL</label>
                      <Tooltip title="" placement="top-end" arrow>
                        <Autocomplete
                          id="free-solo-demo"
                          //freeSolo={true}
                          popupIcon={""}
                          final
                          value={GET_FINAL}
                          options={finalList}
                          onChange={(event, newValue) => {
                            if (newValue) {
                              SET_FINAL(newValue.value);
                            } else {
                              SET_FINAL("");
                            }
                          }}
                          renderInput={(params) => (
                            <TextField {...params} variant="outlined" fullWidth />
                          )}
                          filterOptions={filterOptions}
                        />
                      </Tooltip>
                    </Grid>
                    <Grid item xs={12} sm={2}>
                      <label>INLAND POSTCODE</label>
                      <TextField
                        size="small"
                        name="GET_FINAL_ADDRESS"
                        variant="outlined"
                        fullWidth
                        id="GET_FINAL_ADDRESS"
                        value={GET_FINAL_ADDRESS}
                        onChange={(e) => SET_FINAL_ADDRESS(e.target.value)}
                      />
                    </Grid>
                  </Grid>
                  {
                    /*-----Commodity---*/
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={2}>
                        <label>CARGO TYPE</label>
                        <span className="red">*</span>
                        <Select
                          placeholder="Select..."
                          value={getCargoType}
                          options={optionsCargoType}
                          onChange={handleCargoTypeChange}
                        //required
                        />
                        {errors.cargotype && (
                          <span className="error-message">
                            {errors.cargotype}
                          </span>
                        )}
                      </Grid>

                      <Grid item xs={12} sm={4}>
                        <label>COMMODITY</label>
                        <span className="red">*</span>
                        <TextField
                          size="small"
                          name="GET_COMMODITY"
                          variant="outlined"
                          fullWidth
                          id="GET_COMMODITY"
                          value={GET_COMMODITY}
                          onChange={(e) => SET_COMMODITY(e.target.value)}
                        />
                        {errors.commodityErr && (
                          <span className="error-message">
                            {errors.commodityErr}
                          </span>
                        )}
                      </Grid>
                      <Grid item xs={12} sm={2}>
                        <label>HS Code</label>
                        <TextField
                          size="small"
                          name="GET_HSCODE"
                          variant="outlined"
                          fullWidth
                          id="GET_HSCODE"
                          value={GET_HSCODE}
                          onChange={(e) => SET_HSCODE(e.target.value)}
                        />
                      </Grid>
                      {showDG && (
                        <Grid item xs={12} sm={2}>
                          <label>DG CLASS/UN NO:</label>
                          <span className="red">*</span>
                          <TextField
                            size="small"
                            name="GET_DG_CLASS"
                            variant="outlined"
                            fullWidth
                            id="GET_DG_CLASS"
                            value={GET_DG_CLASS}
                            onChange={(e) => SET_DG_CLASS(e.target.value)}
                            required
                          />
                        </Grid>
                      )}
                    </Grid>
                    /*end Commodity---*/
                  }
                  {showReefer && (
                    <Grid item xs={12} sm={2}>
                      <label>TEMPERATURE</label>
                      <span className="red">*</span>
                      <TextField
                        size="small"
                        name="GET_DG_CLASS"
                        variant="outlined"
                        fullWidth
                        id="GET_DG_CLASS"
                        value={GET_DG_CLASS}
                        onChange={(e) => SET_DG_CLASS(e.target.value)}
                        required
                      />
                    </Grid>
                  )}
                  {showReefer && (
                    <Grid item xs={12} sm={2}>
                      <label>HUMIDITY</label>
                      <span className="red">*</span>
                      <TextField
                        size="small"
                        name="GET_HUMIDITY"
                        variant="outlined"
                        fullWidth
                        id="GET_HUMIDITY"
                        value={GET_HUMIDITY}
                        onChange={(e) => SET_HUMIDITY(e.target.value)}
                        required
                      />
                    </Grid>
                  )}
                  {showReefer && (
                    <Grid item xs={12} sm={2}>
                      <label>VENT</label>
                      <span className="red">*</span>
                      <TextField
                        size="small"
                        name="GET_VENT"
                        variant="outlined"
                        fullWidth
                        id="GET_VENT"
                        value={GET_VENT}
                        onChange={(e) => SET_VENT(e.target.value)}
                        required
                      />
                    </Grid>
                  )}
                  {showReefer && (
                    <Grid item xs={12} sm={3}>
                      <label>PRE COOL</label>
                      <br />
                      <RadioButton
                        name="PRE_COOL"
                        value="Y"
                        text="YES"
                        onChange={handleRadioChangePreCool}
                        checked={isCheckedProcool("Y")}
                      />
                      <RadioButton
                        name="PRE_COOL"
                        value="N"
                        text="NO"
                        onChange={handleRadioChangePreCool}
                        checked={isCheckedProcool("N")}
                      />
                    </Grid>
                  )}
                </Grid>
                <br />
                {/* <div>
  <pre dangerouslySetInnerHTML={{
     __html: JSON.stringify(CarrierInputs, null, 2),
  }} />
</div> */}

                <Grid container spacing={2}>
                  <Grid item xs={12} className="fixpadding-bottom">
                    <label className="head3">CARRIER</label>
                  </Grid>
                  {showFCL && (
                    <Grid item xs={12} sm={4} className="fixpadding-top">
                      <label>Book Priority</label>
                      <span className="red">*</span>
                      <Select
                        styles={{
                          menu: (provided) => ({ ...provided, zIndex: 9999 }),
                        }}
                        placeholder="Select..."
                        value={getPriority}
                        options={priorityOptions}
                        onChange={handlePriorityChange}
                        getOptionLabel={(x) => x.label}
                        getOptionValue={(x) => x.value}
                      />
                      {errors.priority && (
                        <span className="error-message">{errors.priority}</span>
                      )}
                    </Grid>
                  )}
                  {showFCL && (
                    <Grid item xs={12} sm={8}>
                      <label>Waiting Sales to confirm release booking</label>
                      <br />
                      <RadioButton
                        id="YES"
                        name="YES"
                        value="Y"
                        text="YES"
                        onChange={handleRadioChangeWaitingFlag}
                        checked={isCheckedWaitingFlag("Y")}
                      />
                      <RadioButton
                        id="NO"
                        name="NO"
                        value="N"
                        text="NO"
                        onChange={handleRadioChangeWaitingFlag}
                        checked={isCheckedWaitingFlag("N")}
                      />
                    </Grid>
                  )}
                  {/* Carrier for FCL */}
                  <Grid item xs={12} sm={12} className="fixpadding-top">
                    {CarrierInputs.map((item, index) => (
                      <Grid container spacing={2} key={index}>
                        <TextField name="index" value={index} type="hidden" />
                        <TextField
                          //disabled={item.STATUS_NAME== 'ACTIVE' ? false : true}
                          size="small"
                          name="CARRIER_ITEM_ID"
                          value={item.CARRIER_ITEM_ID}
                          type="hidden"
                          onChange={(event) =>
                            handleChangeTextboxCarrier(event, index)
                          }
                        />
                        {item.BOOKING_REF !== "" && item.BOOKING_REF !== null && (
                          <Grid item xs={12} sm={12}>
                            <div className="red">
                              Can not edit this carrier because this item has
                              bookging ref
                            </div>
                          </Grid>
                        )}
                        <Grid item xs={12} sm={2}>
                          <label>CARRIER NAME</label>
                          <span className="red">*</span>
                          <Autocomplete
                            disabled={
                              item.BOOKING_REF !== null && item.BOOKING_REF !== ""
                                ? true
                                : false
                            }
                            id="free-solo-demo"
                            CARRIER_CODE
                            name="CARRIER_CODE"
                            value={item.CARRIER_CODE}
                            options={carrierList}
                            onChange={(event, newValue) => {
                              if (newValue) {
                                updateCarrier(
                                  item.CARRIER_ITEM_ID,
                                  newValue.value,
                                  index
                                );
                              } else {
                                updateCarrier("", index);
                              }
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                variant="outlined"
                                fullWidth
                              />
                            )}
                            sx={{
                              Height: "20px",
                              ...STYLES,
                            }}
                            filterOptions={filterOptions}
                          />
                          {errors.carrierError && (
                            <span className="error-message">
                              {errors.carrierError}
                            </span>
                          )}
                        </Grid>
                        {showFCL && (
                          <Grid item xs={12} sm={2}>
                            <label>SERVICE CONTRACT</label>
                            {item.BOOKING_REF !== "" &&
                              item.BOOKING_REF !== null ? (
                              <TextField
                                disabled={
                                  item.BOOKING_REF !== null &&
                                    item.BOOKING_REF !== ""
                                    ? true
                                    : false
                                }
                                size="small"
                                name="SERVICES_CONTRACT"
                                variant="outlined"
                                fullWidth
                                value={item.SERVICES_CONTRACT}
                                type="text"
                                onChange={(event) =>
                                  handleChangeTextboxCarrier(event, index)
                                }
                              />
                            ) : (
                              <TextField
                                disabled={true}
                                size="small"
                                name="SERVICES_CONTRACT"
                                variant="outlined"
                                fullWidth
                                value={item.SERVICES_CONTRACT}
                                type="text"
                                onChange={(event) =>
                                  handleChangeTextboxCarrier(event, index)
                                }
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <ServiceModal
                                        CARRIER_ITEM_ID={item.CARRIER_ITEM_ID}
                                        CARRIER_CODE={item.CARRIER_CODE}
                                        CARRIER_INDEX={index}
                                        IS_OPEN={GET_OPEN_MODAL}
                                        updateServiceData={updateServiceData}
                                      />
                                    </InputAdornment>
                                  ),
                                }}
                              />
                            )}

                            {errors.svcError && (
                              <span className="error-message">
                                {errors.svcError}
                              </span>
                            )}
                          </Grid>
                        )}

                        {showLCL && (
                          <Grid item xs={12} sm={4}>
                            <label>FREIGHT FORWARDER</label>
                            <span className="red">*</span>
                            <Autocomplete
                              id="free-solo-demo"
                              SERVICES_CONTRACT
                              name="SERVICES_CONTRACT"
                              value={item.SERVICES_CONTRACT}
                              options={LCL_ServiceContract_LIST}
                              onChange={(event, newValue) => {
                                if (newValue) {
                                  update_LCL_ServiceContract(
                                    newValue.value,
                                    index
                                  );
                                } else {
                                  update_LCL_ServiceContract("", index);
                                }
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  variant="outlined"
                                  fullWidth
                                />
                              )}
                              sx={{
                                Height: "20px",
                                ...STYLES,
                              }}
                              filterOptions={filterOptions}
                            />
                            {errors.svcError && (
                              <span className="error-message">
                                {errors.svcError}
                              </span>
                            )}
                          </Grid>
                        )}
                        {showFCL && (
                          <Grid item xs={12} sm={2}>
                            <label>BULLET</label>
                            <TextField
                              disabled={true}
                              // disabled={
                              //   item.BOOKING_REF !== null &&
                              //   item.BOOKING_REF !== ""
                              //     ? true
                              //     : false
                              // }
                              size="small"
                              name="BULLET_CODE"
                              variant="outlined"
                              fullWidth
                              value={item.BULLET_CODE}
                              type="text"
                              onChange={(event) =>
                                handleChangeTextboxCarrier(event, index)
                              }
                            />
                          </Grid>
                        )}
                        {showFCL && (
                          <Grid item xs={12} sm={4}>
                            <label>
                              REMARK
                              {item.SPECIAL_FLAG !== "" &&
                                item.SPECIAL_FLAG !== null &&
                                item.SPECIAL_FLAG == 2 && (
                                  <span className="red">*</span>
                                )}
                            </label>
                            <TextField
                              disabled={
                                item.BOOKING_REF !== null &&
                                  item.BOOKING_REF !== ""
                                  ? true
                                  : false
                              }
                              size="small"
                              name="SCAC"
                              variant="outlined"
                              fullWidth
                              value={item.SCAC}
                              type="text"
                              onChange={(event) =>
                                handleChangeTextboxCarrier(event, index)
                              }
                            />
                            {errors.remarkError && (
                              <span className="error-message">
                                {errors.remarkError}
                              </span>
                            )}
                          </Grid>
                        )}

                        {/* {showFCL && (
                        <Grid item xs={12} sm={4}>
                          <label>VALIDITY</label> */}
                        <TextField
                          size="small"
                          name="SC_VALIDITY"
                          value={item.SC_VALIDITY}
                          type="hidden"
                          onChange={(event) =>
                            handleChangeTextboxCarrier(event, index)
                          }
                        />
                        {/* </Grid>
                      )} */}
                        {item.STATUS_NAME && (
                          <Grid item xs={12} sm={1}>
                            {item.STATUS_NAME == "ACTIVE" ? (
                              <div className="itemlabelgreen">
                                {item.STATUS_NAME}
                              </div>
                            ) : (
                              <div className="itemlabelred">
                                {item.STATUS_NAME}
                              </div>
                            )}
                          </Grid>
                        )}
                        <TextField
                          name="STATUS_NAME"
                          value={item.STATUS_NAME}
                          type="hidden"
                          onChange={(event) =>
                            handleChangeTextboxCarrier(event, index)
                          }
                        />

                        {showFCL && (
                          <Grid
                            item
                            xs={12}
                            sm={1}
                            style={{ display: "flex" }}
                            justify-content="flex-start"
                          >
                            {CarrierInputs.length > 1 &&
                              item.STATUS_NAME == "ACTIVE" &&
                              item.BOOKING_REF == "" && (
                                <DeleteIcon
                                  onClick={() => handleDeleteInputCarrier(index)}
                                  style={{
                                    marginRight: "10px",
                                    marginTop: "35px",
                                    cursor: "pointer",
                                  }}
                                />
                              )}
                            {CarrierInputs.length > 1 &&
                              item.STATUS_NAME == "ACTIVE" &&
                              item.BOOKING_REF == null && (
                                <DeleteIcon
                                  onClick={() => handleDeleteInputCarrier(index)}
                                  style={{
                                    marginRight: "10px",
                                    marginTop: "35px",
                                    cursor: "pointer",
                                  }}
                                />
                              )}
                            {index === CarrierInputs.length - 1 &&
                              CarrierInputs.length < 10 && (
                                <AddBoxIcon
                                  onClick={handleAddInputCarrier}
                                  style={{ marginTop: "35px", cursor: "pointer" }}
                                />
                              )}
                          </Grid>
                        )}
                        {item.SPECIAL_FLAG !== "" &&
                          item.SPECIAL_FLAG !== null &&
                          item.SPECIAL_FLAG == 3 && (
                            <Grid item xs={12} sm={12}>
                              <div className="labelError">
                                Description: {item.SC_CONDITION}
                                <hr />
                              </div>
                            </Grid>
                          )}
                        {item.SPECIAL_FLAG !== "" &&
                          item.SPECIAL_FLAG !== null &&
                          item.SPECIAL_FLAG == 2 && (
                            <Grid item xs={12} sm={12}>
                              <div className="labelError">
                                Description: {item.SC_CONDITION}
                                <hr />
                              </div>
                            </Grid>
                          )}
                        {item.SPECIAL_FLAG !== "" &&
                          item.SPECIAL_FLAG !== null &&
                          item.SPECIAL_FLAG == 1 && (
                            <Grid item xs={12} sm={12}>
                              <div className="labelnormal">
                                Description: {item.SC_CONDITION}
                                <hr />
                              </div>
                            </Grid>
                          )}
                        {showFCL && (
                          <TextField
                            size="small"
                            name="SC_CONDITION"
                            value={item.SC_CONDITION}
                            type="hidden"
                            onChange={(event) =>
                              handleChangeTextboxCarrier(event, index)
                            }
                          />
                        )}
                        {showFCL && (
                          <TextField
                            size="small"
                            name="SPECIAL_FLAG"
                            value={item.SPECIAL_FLAG}
                            type="hidden"
                            onChange={(event) =>
                              handleChangeTextboxCarrier(event, index)
                            }
                          />
                        )}
                      </Grid>
                    ))}
                  </Grid>
                  {/* end carrier for fcl */}
                  {/* volume for fcl */}
                  <Grid item xs={12} className="fixpadding-bottom">
                    <label className="head3">VOLUME</label>
                    {containerFormError && (
                      <span className="error-message">{containerFormError}</span>
                    )}
                  </Grid>
                  {showFCL && (
                    <Grid container spacing={2}>
                      {containerFields.map(({ key, label }) => (
                        <Grid item xs={12} sm={6} md={3} key={key}>
                          {/* 🔹 กล่องต่อ 1 container */}
                          <Paper
                            elevation={1}
                            sx={{
                              p: 1,
                              mb: 0,
                              height: "100%",
                              backgroundColor: "#f0f2f7",
                              boxShadow: "0",
                            }}
                          >
                            {/* Header */}
                            <Box sx={{ fontWeight: 400, mb: 1 }}>
                              <label>Container {label}</label>
                            </Box>

                            {/* ฟอร์มในกล่อง */}
                            <Grid container spacing={1}>
                              {/* TYPE */}
                              <Grid item xs={4}>
                                <Typography variant="caption" sx={{ mb: 0.25 }}>
                                  TYPE
                                </Typography>

                                <Autocomplete
                                  options={optionsContainerType}
                                  value={containers[key].type}
                                  onChange={(event, newValue) => {
                                    updateContainer(
                                      key,
                                      "type",
                                      newValue ? newValue.value : ""
                                    );
                                  }}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      variant="outlined"
                                      fullWidth
                                    />
                                  )}
                                />
                              </Grid>

                              {/* QTY */}
                              <Grid item xs={4}>
                                <Typography variant="caption" sx={{ mb: 0.25 }}>
                                  QTY
                                </Typography>
                                <TextField
                                  type="number"
                                  size="small"
                                  variant="outlined"
                                  fullWidth
                                  inputProps={{ min: 0 }}
                                  value={containers[key].cnt}
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    updateContainer(key, "cnt", value);
                                    validateContainerForm(key, value);
                                  }}
                                  error={Boolean(containers[key].errors?.cnt)}
                                  helperText={containers[key].errors?.cnt}
                                />
                              </Grid>

                              {/* GW */}
                              <Grid item xs={4}>
                                <Typography variant="caption" sx={{ mb: 0.25 }}>
                                  Max GW / Ctnr
                                </Typography>

                                <TextField
                                  type="number"
                                  size="small"
                                  variant="outlined"
                                  fullWidth
                                  inputProps={{
                                    min: 0,
                                    step: "any", // ⭐ อนุญาตทศนิยม
                                  }}
                                  value={containers[key].gw}
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    updateContainer(key, "gw", value);
                                    validateContainerForm(key, value);
                                  }}
                                  onBlur={() => checkOverWeightOnBlur(key)}
                                  error={Boolean(containers[key].errors?.gw)}
                                  helperText={containers[key].errors?.gw}
                                />
                              </Grid>
                            </Grid>
                          </Paper>
                        </Grid>
                      ))}
                    </Grid>
                  )}

                  {showLCL && (
                    <Grid item xs={12} sm={3}>
                      <label>NUMBER OF PACKAGES (Number Only)</label>
                      <span className="red">*</span>
                      <TextField
                        type="number"
                        size="small"
                        name="GET_NO_OF_PACK"
                        variant="outlined"
                        fullWidth
                        id="GET_NO_OF_PACK"
                        value={GET_NO_OF_PACK}
                        onChange={(e) => SET_NO_OF_PACK(e.target.value)}
                      />
                      {errors.GET_NO_OF_PACK_ERR && (
                        <span className="error-message">
                          {errors.GET_NO_OF_PACK_ERR}
                        </span>
                      )}
                    </Grid>
                  )}

                  {showLCL && (
                    <Grid item xs={12} sm={2}>
                      <label>PACKAGE UNIT</label>
                      <span className="red">*</span>
                      <TextField
                        size="small"
                        name="GET_PACKAGE_UNIT"
                        variant="outlined"
                        fullWidth
                        id="GET_PACKAGE_UNIT"
                        value={GET_PACKAGE_UNIT}
                        onChange={(e) => SET_PACKAGE_UNIT(e.target.value)}
                      />
                      {errors.GET_PACKAGE_UNIT_ERR && (
                        <span className="error-message">
                          {errors.GET_PACKAGE_UNIT_ERR}
                        </span>
                      )}
                    </Grid>
                  )}
                  {showLCL && (
                    <Grid item xs={12} sm={2}>
                      <label>CBM</label>
                      <span className="red">*</span>
                      <TextField
                        size="small"
                        name="GET_CBM"
                        variant="outlined"
                        fullWidth
                        id="GET_CBM"
                        value={GET_CBM}
                        type="number"
                        onChange={(e) => SET_CBM(e.target.value)}
                      />
                      {errors.GET_CBM_ERR && (
                        <span className="error-message">
                          {errors.GET_CBM_ERR}
                        </span>
                      )}
                    </Grid>
                  )}
                  <Grid item xs={12} sm={5}>
                    {showFCL ? (
                      <label>GW Remark (If any)</label>
                    ) : showLCL ? (
                      <label>
                        GW Remark <span className="red">*</span>
                      </label>
                    ) : null}
                    <TextField
                      size="small"
                      name="GET_GW"
                      variant="outlined"
                      fullWidth
                      id="GET_GW"
                      value={GET_GW}
                      onChange={(e) => SET_GW(e.target.value)}
                    />
                    {errors.GET_GW_ERR && (
                      <span className="error-message">{errors.GET_GW_ERR}</span>
                    )}
                  </Grid>
                  {showFCL && (
                    <Grid item xs={12} sm={6}>
                      &nbsp;
                    </Grid>
                  )}
                  {showLCL && (
                    <Grid item xs={12} sm={4}>
                      &nbsp;
                    </Grid>
                  )}
                  <Grid item xs={12} sm={12}>
                    {errors.volume && (
                      <span className="error-message">{errors.volume}</span>
                    )}
                    {errors.volume20 && (
                      <span className="error-message">{errors.volume20}</span>
                    )}
                    {errors.volume40 && (
                      <span className="error-message">{errors.volume40}</span>
                    )}
                    {errors.volume45 && (
                      <span className="error-message">{errors.volume45}</span>
                    )}
                    {errors.volume40HQ && (
                      <span className="error-message">{errors.volume40HQ}</span>
                    )}
                  </Grid>
                  {showLCL && (
                    <Grid item xs={12} sm={8}>
                      <label className="head3">
                        Dimension Note&nbsp;&nbsp;&nbsp;
                        {/* <span className="error-message inline">
                        *Please click <SaveIcon /> button before change tab.
                      </span> */}
                      </label>
                      {/* <ThemeProvider theme={myTheme}> */}
                      <MUIRichTextEditor
                        className="mui-rte-editor"
                        label="Dimension note..."
                        inlineToolbar={true}
                        controls={[
                          "title",
                          "bold",
                          "italic",
                          "underline",
                          "highlight",
                          "link",
                          "numberList",
                          "bulletList",
                        ]}
                        ref={editorRef}
                        defaultValue={GET_CONTENT}
                        onSave={(value) => SET_CONTENT(value)}
                        onChange={(value) => SET_DIMENSION_NOTE(stateToHTML(value.getCurrentContent()))}
                      />
                      {/* </ThemeProvider> */}

                      {showErrorComment}
                    </Grid>
                  )}
                  <Grid item xs={12} sm={12}>
                    <label>Attach Files</label>
                    <div className="kb-file-upload">
                      <div className="file-upload-box">
                        <input
                          type="file"
                          id="fileupload"
                          className="file-upload-input"
                          onChange={InputChange}
                          multiple
                        />
                        <span>
                          Drag and drop or{" "}
                          <span className="file-link">Choose your files</span>
                        </span>
                      </div>
                    </div>
                    <div className="kb-attach-box mb-3">
                      {selectedfile.map((data, index) => {
                        const { id, filename, filesize } = data;
                        return (
                          <div className="file-atc-box" key={id}>
                            <div className="file-detail">
                              <h6>{filename}</h6>
                              <p>
                                <span>Size : {filesize}</span>
                              </p>
                              {/* <div className="file-actions">
                        <button
                          type="button"
                          className="file-action-btn"
                          onClick={() => DeleteSelectFile(id, index)}
                        >
                          Delete before submit
                        </button>
                      </div> */}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                    {files.name > 0 ? (
                      <div className="kb-attach-box">
                        <hr />
                        {files.map((data, index) => {
                          const { id, filename, filesize } = data;
                          return (
                            <div className="file-atc-box" key={index}>
                              <div className="file-detail">
                                <h6>{filename}</h6>
                                <p>
                                  <span>Size : {filesize}</span>
                                </p>
                                <div className="file-actions">
                                  <button
                                    className="file-action-btn"
                                    onClick={() => DeleteFile(id, index)}
                                  >
                                    Delete
                                  </button>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    ) : (
                      ""
                    )}
                    {files && (
                      <Button
                        type="button"
                        variant="outlined"
                        color="primary"
                        onClick={handleFileUpload}
                      >
                        &uarr; Click to Upload{" "}
                        {files.length > 1 ? "files" : " file"}
                      </Button>
                    )}
                    &nbsp; &nbsp; &nbsp;
                    <label>{showUploadMsg}</label>
                  </Grid>
                  {/*   <Grid item xs={12} sm={12}>
                  <label>ATTACHED FILE </label> &nbsp;&nbsp;
                  <input type="file" multiple onChange={handleFileChange} />
                  {files &&
                    [...files].map((file, index) => (
                      <section key={file.name}>
                        File number {index + 1} details:
                        <ul>
                          <li>Name: {file.name}</li>
                          <li>Type: {file.type}</li>
                          <li>Size: {readableBytes(file.size)}</li>
                        </ul>
                      </section>
                    ))}
                  {files && (
                    <Button
                      type="button"
                      variant="outlined"
                      color="primary"
                      onClick={handleFileUpload}
                    >
                      &uarr; Upload {files.length > 1 ? "files" : "a file"}
                    </Button>
                  )}
                  &nbsp; &nbsp; &nbsp;
                  <label>{showUploadMsg}</label>
                </Grid>*/}
                  {getAttachment && (
                    <Grid item xs={12} sm={12}>
                      <label>File:</label>
                      <p className="data">{ReactHtmlParser(returnStr)}</p>
                    </Grid>
                  )}
                  {errors.fileerror && (
                    <span className="error-message">{errors.fileerror}</span>
                  )}
                  {errorMessage && (
                    <Grid item xs={12} sm={12}>
                      <label className="red">{errorMessage}</label>
                    </Grid>
                  )}

                  <Grid item xs={12} sm={12}>
                    <label>
                      -Allow file type jpg, jpeg, png, gif, pdf
                      <br />
                      -Total file size must not exceed 30 mb.
                    </label>
                  </Grid>
                </Grid>

                {/* end tab 1 */}
              </TabPanel>
              <TabPanel value="2">
                {/* tab2 */}
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} className="fixpadding-bottom">
                        <label className="head3">SHIPMENT TERM</label>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <label>LOAD TYPE</label>
                        <span className="red">*</span>
                        {showFCL && (
                          <Select
                            placeholder="Select..."
                            value={getLoadType}
                            options={optionsLoadType}
                            onChange={handleLoadTypeChange}
                            required
                          />
                        )}
                        {showLCL && (
                          <Select
                            placeholder="Select..."
                            value={getLoadType}
                            options={optionsLoadTypeLCL}
                            onChange={handleLoadTypeChange}
                            required
                          />
                        )}
                        {errors.loadtype && (
                          <span className="error-message">{errors.loadtype}</span>
                        )}
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <label>INCOTERM</label>
                        <span className="red">*</span>
                        <Select
                          placeholder="Select..."
                          value={getIncoterm}
                          options={optionsIncoterm}
                          onChange={handleIncotermChange}
                        />
                        {errors.incotermErr && (
                          <span className="error-message">
                            {errors.incotermErr}
                          </span>
                        )}
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <label>CY TERM</label>
                        <span className="red">*</span>
                        <Select
                          placeholder="Select..."
                          value={getCyTerm}
                          options={optionsCyTerm}
                          onChange={handleCyTermChange}
                        />
                        {errors.cyterm && (
                          <span className="error-message">{errors.cyterm}</span>
                        )}
                      </Grid>
                      {showDoorBy && (
                        <Grid item xs={12} sm={6}>
                          {/* ถ้า 4 ตัวท้าย cy term เป็น door ค่อยโชว์ */}

                          <label>DOOR BY</label>
                          <br />
                          <RadioButton
                            id="AGENT"
                            name="AGENT"
                            value="AGENT"
                            text="AGENT"
                            onChange={handleRadioChangeDoorBy}
                            checked={isCheckedDoorBy("AGENT")}
                          />
                          <RadioButton
                            id="CARRIER"
                            name="CARRIER"
                            value="CARRIER"
                            text="CARRIER"
                            onChange={handleRadioChangeDoorBy}
                            checked={isCheckedDoorBy("CARRIER")}
                          />
                        </Grid>
                      )}
                    </Grid>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        &nbsp;
                      </Grid>
                      <Grid item xs={12} className="fixpadding-bottom">
                        <label className="head3">ORIGIN SERVICES</label>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <label>Shipping by</label>
                        <TextField
                          size="small"
                          name="GET_SHIPPING"
                          variant="outlined"
                          fullWidth
                          id="GET_SHIPPING"
                          value={GET_SHIPPING}
                          onChange={(e) => SET_SHIPPING(e.target.value)}
                        />
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <label>Insurance by</label>
                        <TextField
                          size="small"
                          name="GET_INSURANCE"
                          variant="outlined"
                          fullWidth
                          id="GET_INSURANCE"
                          value={GET_INSURANCE}
                          onChange={(e) => SET_INSURANCE(e.target.value)}
                        />
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <label>
                          Truck by {radioStatus == "EXPORT" && <span className="red">*</span>}
                        </label>

                        <Select
                          placeholder="Select..."
                          value={GET_TRUCKING}
                          options={optionsTruck_BY}
                          onChange={handleTruckbyChange}
                          required={radioStatus == "EXPORT"}
                          disabled={radioStatus == "IMPORT"}
                        />
                        {errors.truckby && (
                          <span className="error-message">{errors.truckby}</span>
                        )}
                        {/* <TextField
                        size="small"
                        name="GET_TRUCKING"
                        variant="outlined"
                        fullWidth
                        id="GET_TRUCKING"
                        value={GET_TRUCKING}
                        onChange={(e) => SET_TRUCKING(e.target.value)}
                      /> */}
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <label>Remark</label>
                        <TextField
                          size="small"
                          name="GET_TRUCKBY_REMARK"
                          variant="outlined"
                          fullWidth
                          id="GET_TRUCKBY_REMARK"
                          value={GET_TRUCKBY_REMARK}
                          onChange={(e) => SET_TRUCKBY_REMARK(e.target.value)}
                        />
                      </Grid>
                      <Grid item xs={12} className="fixpadding-bottom">
                        <label className="head3">DELIVERY SERVICES</label>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <label>Shipping by</label>
                        <TextField
                          size="small"
                          name="GET_SHIPPING_DEL"
                          variant="outlined"
                          fullWidth
                          id="GET_SHIPPING_DEL"
                          value={GET_SHIPPING_DEL}
                          onChange={(e) => SET_SHIPPING_DEL(e.target.value)}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <label>Truck by</label>
                        <TextField
                          size="small"
                          name="GET_TRUCKING_DEL"
                          variant="outlined"
                          fullWidth
                          id="GET_TRUCKING_DEL"
                          value={GET_TRUCKING_DEL}
                          onChange={(e) => SET_TRUCKING_DEL(e.target.value)}
                        />
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        &nbsp;
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} className="fixpadding-bottom">
                        <label className="head3">DOCUMENT TYPE</label>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label>Master BL TERM</label>
                        <span className="red">*</span>
                        <Select
                          placeholder="Select..."
                          value={getMBLTerm}
                          options={optionsBLTerm}
                          onChange={handleMBLTermChange}
                          required
                        />
                        {errors.mblterm && (
                          <span className="error-message">{errors.mblterm}</span>
                        )}
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label>Master BL TYPE</label>
                        <span className="red">*</span>
                        <Select
                          placeholder="Select..."
                          value={getMBLType}
                          options={optionsBLType}
                          onChange={handleMBLTypeChange}
                          required
                        />
                        {errors.mbltype && (
                          <span className="error-message">{errors.mbltype}</span>
                        )}
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        &nbsp;
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label>House BL TERM</label>
                        <Select
                          placeholder="Select..."
                          value={getHBLTerm}
                          options={optionsBLTerm}
                          onChange={handleHBLTermChange}
                          isClearable
                        />
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <label>House BL TYPE</label>
                        <Select
                          placeholder="Select..."
                          value={getHBLType}
                          options={optionsBLType}
                          onChange={handleHBLTypeChange}
                          isClearable
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} className="hideMobile">
                        &nbsp;
                      </Grid>
                    </Grid>
                    <Grid item sm={12} className="hideMobile">
                      &nbsp;
                    </Grid>
                    <Grid item sm={12}>
                      &nbsp;
                    </Grid>
                    <Grid container spacing={2}>
                      <Grid item xs={12} className="fixpadding-bottom">
                        <label className="head3">MANIFEST FILING</label>
                      </Grid>
                      <Grid item xs={12} sm={6}>

                        <label>AMS/ACI Filing by</label>
                        {radioStatus == "EXPORT" && <span className="red">*</span>}
                        <Select
                          placeholder="Select..."
                          value={GET_AMS_SCAC}
                          options={optionsAMS_SCAC}
                          onChange={handleAMS_SCACChange}
                          required
                        />
                        {errors.AMS && (
                          <span className="error-message">{errors.AMS}</span>
                        )}
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <label>ISF Filing by</label>
                        {radioStatus == "EXPORT" && <span className="red">*</span>}
                        <Select
                          placeholder="Select..."
                          value={GET_ISF_BY}
                          options={optionsISF_BY}
                          onChange={handleISF_BYChange}
                          required
                        />
                        {errors.ISF && (
                          <span className="error-message">{errors.ISF}</span>
                        )}
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        &nbsp;
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        &nbsp;
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>

                {/* end tab 2 */}
              </TabPanel>
              <TabPanel value="3">
                {/* tab 3*/}
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={4}>
                    <label>CUSTOMER</label>
                    <span className="required">*</span>
                    <Select
                      className="multiselect1"
                      placeholder="Select..."
                      value={getShipper}
                      options={shipperList}
                      onChange={handleShipperChange}
                      getOptionLabel={(x) => x.COM_NAME}
                      getOptionValue={(x) => x.COM_CODE}
                    />
                    {errors.shipper && (
                      <span className="error-message">{errors.shipper}</span>
                    )}
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <label>CONSIGNEE</label>
                    <Select
                      className="multiselect1"
                      placeholder="Select..."
                      value={getConsignee}
                      options={ConsigneeList}
                      onChange={handleConsigneeChange}
                      getOptionLabel={(x) => x.COM_NAME}
                      getOptionValue={(x) => x.COM_CODE}
                      isClearable
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <label>AGENT</label>
                    <Select
                      className="multiselect2"
                      placeholder="Select..."
                      value={getAgent}
                      options={agentList}
                      onChange={handleAgentChange}
                      getOptionLabel={(x) => x.COM_NAME}
                      getOptionValue={(x) => x.COM_CODE}
                      isClearable
                    />
                  </Grid>

                  <Grid item xs={12} sm={4}>
                    <label>ACTUAL SHIPPER/SHIPPER LOAD</label>
                    <Select
                      className="multiselect2"
                      placeholder="Select..."
                      value={getShipperLoad}
                      options={shipperLoadList}
                      onChange={handleShipperLoadChange}
                      getOptionLabel={(x) => x.COM_NAME}
                      getOptionValue={(x) => x.COM_CODE}
                      isClearable
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <label>CO LOAD</label>
                    <Select
                      className="multiselect3"
                      placeholder="Select..."
                      value={getCoload}
                      options={coloadList}
                      onChange={handleColoadChange}
                      getOptionLabel={(x) => x.COM_NAME}
                      getOptionValue={(x) => x.COM_CODE}
                      isClearable
                    />
                  </Grid>

                  <Grid item xs={12} sm={4}>
                    <label>3rd partry shipment</label>
                    <TextField
                      size="small"
                      name="GET_PARTY_3RD_NAME"
                      variant="outlined"
                      fullWidth
                      id="GET_PARTY_3RD_NAME"
                      value={GET_PARTY_3RD_NAME}
                      onChange={(e) => SET_PARTY_3RD_NAME(e.target.value)}
                    />
                  </Grid>

                  <Grid item xs={12} sm={4}>
                    <label>CREDIT TERM</label>
                    <TextField
                      size="small"
                      name="GET_CREDIT_TERM"
                      variant="outlined"
                      fullWidth
                      id="GET_CREDIT_TERM"
                      value={GET_CREDIT_TERM}
                      onChange={(e) => SET_CREDIT_TERM(e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}></Grid>
                  <Grid item xs={12} sm={4}></Grid>
                  <Grid item xs={12} sm={3}>
                    <label>AGENT SALES EMAIL</label>
                    <Box
                      component="textarea"
                      value={GET_AGENT_SALES_EMAIL}
                      onChange={(e) => SET_AGENT_SALES_EMAIL(e.target.value)}
                      rows={2}
                      inputProps={{ maxLength: 500 }}
                      style={{
                        width: "100%",
                        padding: "8px",
                        boxSizing: "border-box",
                        resize: "none",
                        verticalAlign: "top",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        fontSize: "14px",
                        fontFamily: "Roboto, sans-serif",
                      }}
                    />
                    {/* <TextField
                    size="small"
                    name="GET_AGENT_SALES_EMAIL"
                    variant="outlined"
                    fullWidth
                    id="GET_AGENT_SALES_EMAIL"
                    value={GET_AGENT_SALES_EMAIL}
                    onChange={(e) => SET_AGENT_SALES_EMAIL(e.target.value)}
                    multiline
                    rows={8}
                  /> */}
                  </Grid>
                  <Grid item xs={12} sm={3}>
                    <label>PREALERT EMAIL</label>
                    <Box
                      component="textarea"
                      value={GET_PREALERT_EMAIL}
                      onChange={(e) => SET_PREALERT_EMAIL(e.target.value)}
                      rows={2}
                      inputProps={{ maxLength: 500 }}
                      style={{
                        width: "100%",
                        padding: "8px",
                        boxSizing: "border-box",
                        resize: "none",
                        verticalAlign: "top",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        fontSize: "14px",
                        fontFamily: "Roboto, sans-serif",
                      }}
                    />
                    {/* <TextField
                    size="small"
                    name="GET_PREALERT_EMAIL"
                    variant="outlined"
                    fullWidth
                    id="GET_PREALERT_EMAIL"
                    value={GET_PREALERT_EMAIL}
                    onChange={(e) => SET_PREALERT_EMAIL(e.target.value)}
                    multiline
                    rows={8}
                  /> */}
                  </Grid>
                  <Grid item xs={12} sm={3}>
                    <label>BOOKING PIC</label>
                    <Box
                      component="textarea"
                      value={GET_BOOKING_PIC}
                      onChange={(e) => SET_BOOKING_PIC(e.target.value)}
                      rows={2}
                      inputProps={{ maxLength: 500 }}
                      style={{
                        width: "100%",
                        padding: "8px",
                        boxSizing: "border-box",
                        resize: "none",
                        verticalAlign: "top",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        fontSize: "14px",
                        fontFamily: "Roboto, sans-serif",
                      }}
                    />
                    {/* <TextField
                    size="small"
                    name="GET_BOOKING_PIC"
                    variant="outlined"
                    fullWidth
                    id="GET_BOOKING_PIC"
                    value={GET_BOOKING_PIC}
                    onChange={(e) => SET_BOOKING_PIC(e.target.value)}
                    multiline
                    rows={8}
                  /> */}
                  </Grid>
                  <Grid item xs={12} sm={3}>
                    <label>DOC PIC</label>
                    <Box
                      component="textarea"
                      value={GET_DOC_PIC}
                      onChange={(e) => SET_DOC_PIC(e.target.value)}
                      rows={2}
                      inputProps={{ maxLength: 500 }}
                      style={{
                        width: "100%",
                        padding: "8px",
                        boxSizing: "border-box",
                        resize: "none",
                        verticalAlign: "top",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        fontSize: "14px",
                        fontFamily: "Roboto, sans-serif",
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <label>REMARK TO CS</label>
                    {getValue == "3" && renderEditor && (
                      <Box sx={{ width: "100%" }}>
                        {/* <ThemeProvider theme={myTheme}> */}
                        <MUIRichTextEditor
                          className="mui-rte-editor"
                          label="Type your remark here..."
                          inlineToolbar={true}
                          controls={[
                            "title",
                            "bold",
                            "italic",
                            "underline",
                            "link",
                            "numberList",
                            "bulletList",
                          ]}
                          ref={editorRef2}
                          defaultValue={GET_CONTENT_CS}
                          onSave={(value) => SET_CONTENT_CS(value)}
                          onChange={(value) => SET_REMARK_TO_CS(stateToHTML(value.getCurrentContent()))}
                        />
                        {/* </ThemeProvider> */}
                      </Box>
                    )}

                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <label>REMARK TO DOC</label>
                    {getValue == "3" && renderEditor && (
                      <Box sx={{ width: "100%" }}>
                        {/* <ThemeProvider theme={myTheme}> */}
                        <MUIRichTextEditor
                          className="mui-rte-editor"
                          label="Type your remark here..."
                          inlineToolbar={true}
                          controls={[
                            "title",
                            "bold",
                            "italic",
                            "underline",
                            "link",
                            "numberList",
                            "bulletList",
                          ]}
                          ref={editorRef3}
                          defaultValue={GET_CONTENT_DOC}
                          onSave={(value) => SET_CONTENT_DOC(value)}
                          onChange={(value) => SET_REMARK_TO_DOC(stateToHTML(value.getCurrentContent()))}
                        />
                        {/* </ThemeProvider> */}
                      </Box>
                    )}

                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <label>REMARK TO ACC</label>
                    {getValue == "3" && renderEditor && (
                      <Box sx={{ width: "100%" }}>
                        {/* <ThemeProvider theme={myTheme}> */}
                        <MUIRichTextEditor
                          className="mui-rte-editor"
                          label="Type your remark here..."
                          inlineToolbar={true}
                          controls={[
                            "title",
                            "bold",
                            "italic",
                            "underline",
                            "link",
                            "numberList",
                            "bulletList",
                          ]}
                          ref={editorRef4}
                          defaultValue={GET_CONTENT_ACC}
                          onSave={(value) => SET_CONTENT_ACC(value)}
                          onChange={(value) => SET_REMARK_TO_ACC(stateToHTML(value.getCurrentContent()))}
                        />
                        {/* </ThemeProvider> */}
                      </Box>
                    )}

                  </Grid>


                  {showFCL && (
                    <Grid item xs={12} sm={4}>
                      <label>Additional remark for Sales report</label>
                      <TextField
                        size="small"
                        name="GET_REMARK_TO_REPORT"
                        variant="outlined"
                        fullWidth
                        id="GET_REMARK_TO_REPORT"
                        value={GET_REMARK_TO_REPORT}
                        onChange={(e) => SET_REMARK_TO_REPORT(e.target.value)}
                        inputProps={{ maxLength: 50 }}

                      />
                    </Grid>

                  )}
                  {showFCL && (<Grid item xs={12} sm={8}></Grid>)}
                </Grid>
                {/* end tab 3 */}
              </TabPanel>
            </TabContext>
          </ThemeProvider>
        </Box>

        <Grid container spacing={2}>
          {errors && (
            <Grid item xs={12} sm={12}>
              {errors.quotation && (
                <span className="error-message">{errors.quotation}</span>
              )}
              {errors.getSaleError && (
                <span className="error-message">{errors.getSaleError}</span>
              )}
              {errors.getCsError && (
                <span className="error-message">{errors.getCsError}</span>
              )}
              {errors.etdDate && (
                <span className="error-message">{errors.etdDate}</span>
              )}
              {errors.por && (
                <span className="error-message">{errors.por}</span>
              )}
              {errors.pol && (
                <span className="error-message">{errors.pol}</span>
              )}
              {errors.pod && (
                <span className="error-message">{errors.pod}</span>
              )}

              {errors.cargotype && (
                <span className="error-message">{errors.cargotype}</span>
              )}
              {errors.commodityErr && (
                <span className="error-message">{errors.commodityErr}</span>
              )}
              {errors.carrierError && (
                <span className="error-message">{errors.carrierError}</span>
              )}
              {errors.remarkError && (
                <span className="error-message">{errors.remarkError}</span>
              )}
              {errors.volume && (
                <span className="error-message">{errors.volume}</span>
              )}
              {errors.volume20 && (
                <span className="error-message">{errors.volume20}</span>
              )}
              {errors.volume40 && (
                <span className="error-message">{errors.volume40}</span>
              )}
              {errors.volume45 && (
                <span className="error-message">{errors.volume45}</span>
              )}
              {errors.volume40HQ && (
                <span className="error-message">{errors.volume40HQ}</span>
              )}
              {errors.containerSizeError && (
                <span className="error-message">
                  {errors.containerSizeError}
                </span>
              )}
              {errors.containerTypeError && (
                <span className="error-message">
                  {errors.containerTypeError}
                </span>
              )}

              {errors.containerQtyError && (
                <span className="error-message">
                  {errors.containerQtyError}
                </span>
              )}
              {errors.containerGwError && (
                <span className="error-message">{errors.containerGwError}</span>
              )}
              {errors.containerUnitError && (
                <span className="error-message">
                  {errors.containerUnitError}
                </span>
              )}
              {errors.containerCbmError && (
                <span className="error-message">
                  {errors.containerCbmError}
                </span>
              )}
              {errors.GET_NO_OF_PACK_ERR && (
                <span className="error-message">
                  {errors.GET_NO_OF_PACK_ERR}
                </span>
              )}
              {errors.GET_PACKAGE_UNIT_ERR && (
                <span className="error-message">
                  {errors.GET_PACKAGE_UNIT_ERR}
                </span>
              )}
              {errors.GET_CBM_ERR && (
                <span className="error-message">{errors.GET_CBM_ERR}</span>
              )}
              {errors.GET_GW_ERR && (
                <span className="error-message">{errors.GET_GW_ERR}</span>
              )}
              {/* {errors.fileerror && (
                <span className="error-message">{errors.fileerror}</span>
              )} */}
              {errors.loadtype && (
                <span className="error-message">{errors.loadtype}</span>
              )}
              {errors.incotermErr && (
                <span className="error-message">{errors.incotermErr}</span>
              )}
              {errors.cyterm && (
                <span className="error-message">{errors.cyterm}</span>
              )}
              {errors.mblterm && (
                <span className="error-message">{errors.mblterm}</span>
              )}
              {errors.mbltype && (
                <span className="error-message">{errors.mbltype}</span>
              )}
              {errors.truckby && (
                <span className="error-message">{errors.truckby}</span>
              )}
              {errors.AMS && (
                <span className="error-message">{errors.AMS}</span>
              )}
              {errors.ISF && (
                <span className="error-message">{errors.ISF}</span>
              )}
              {errors.shipper && (
                <span className="error-message">{errors.shipper}</span>
              )}
            </Grid>
          )}
          {showLCL && <Grid item xs={12} sm={6}></Grid>}


          {showFCL && <Grid item xs={12} sm={3}></Grid>}
          {showFCL && (
            <Grid
              item
              xs={12}
              sm={2}
              style={{ display: "flex" }}
              justify="flex-end"
            >
              {" "}
              <label className="labeltext">Duplicate Order</label>
            </Grid>
          )}
          {showFCL && (
            <Grid item xs={12} sm={1}>
              <TextField
                type="number"
                InputProps={{
                  inputProps: { min: 1 },
                  disabled: isDisableDup,
                }}
                onKeyPress={(event) => {
                  if (
                    event?.key === "-" ||
                    event?.key === "+" ||
                    event?.key === "0"
                  ) {
                    event.preventDefault();
                  }
                }}
                size="small"
                name="GET_DUP_ORDER"
                variant="outlined"
                fullWidth
                id="GET_DUP_ORDER"
                value={GET_DUP_ORDER}
                onChange={(e) => SET_DUP_ORDER(e.target.value)}
                required
              />
            </Grid>
          )}
          <Grid item xs={12} sm={6}>
            <Button
              isLoading={isSubmitting}
              disabled={!isButtonDisabled}
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
            >
              Save
            </Button>
          </Grid>
        </Grid>
      </form>
    </Container>
  );
}
